// ESM-Huelle um lib/scripts/pos/CLS_CBonTransaction.js (Phase 4, Welle 3d) -
// die zentrale Bon-Datenschicht (154 SQL-Statements; verbleibender God-
// Node, wird spaeter inkrementell in Scheiben zerlegt). Prototype-Stil
// bleibt vorerst.

// Strict-Mode-Fix (ESM): implizite Global-Zuweisungen des Sloppy-Mode
// modulweit deklarieren (siehe Welle-3-Muster).
var i, sql, secondId;
function CBonTransaction() {
    this.UID = POS.sessions.currentSession;
}

CBonTransaction.prototype.openBon = function (userId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    if (!userId)
        var U_ID = this.UID;
    else
        U_ID = userId;

    var sql = "SELECT Name, Login FROM U Where U_ID = " + U_ID;
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        var dbUName = rows[0].Name;
        var dbULogin = rows[0].Login;
        //r.free();

        // Write Start Entry with User and POS information
        var d = new Date();
        sql = "INSERT INTO BON " +
            "(Closed, Start, End, POS_ID, U_ID, UName, Cancelled, Type, CUST_ID, Exported) " +
            "VALUES (0, " + (d / 1000).toFixed(0) + ", 0, " + POS.POSId + ", " +
            dbULogin + ", '" + dbUName + "', 0, 'NEW', NULL, 0)";

        // Nummer ohne Luecke zum INSERT holen (insertMitId, core/sqlite.js).
        $.when(POS.SQLiteCon.insertMitId(sql)).then(function (id) {
            // Return Bon Id
            dfd.resolve(id);
        });
    });
    return dfd.promise();
}

CBonTransaction.prototype.makePOSId = function (bonId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "INSERT INTO POSBON (BON_ID) VALUES (" + bonId + ")";

    // Nummer ohne Luecke zum INSERT holen (insertMitId, core/sqlite.js).
    $.when(POS.SQLiteCon.insertMitId(sql, "POSBON_ID", "POSBON")).then(function (POSBonId) {
        dfd.resolve(POSBonId);
    });
    return dfd.promise();
}

CBonTransaction.prototype.closeBon = function (id, type, custId) {
    /*privMan.enablePrivilege (privList);*/

    var d = new Date();
    // Write Start Entry with User and POS information
    var sql = "UPDATE BON SET Closed = -1, End = " + (d / 1000).toFixed(0) +
        ", Type = '" + type + "', CUST_ID = " + (custId ? custId : "NULL") +
        ", Exported = 0 WHERE BON_ID = " + id;

    return POS.SQLiteCon.execute(sql);
}

CBonTransaction.prototype.runLID = function (id, type) {
    /*privMan.enablePrivilege (privList);*/

    var Time1 = getNow();
    for (var i = 0; i < 10; i++) {
        this.runLIDSub();
    }
    measure(Time1, " - -XXXXXXX");
}

CBonTransaction.prototype.runLIDSub = function (id, type) {
    /*privMan.enablePrivilege (privList);*/
    /*
    for (var i = 0; i < 100; i++)
{
    var Time1 = getNow();
    var sql = "insert into BONE (Type, Qty) values ('OOO', 4)";
    POS.SQLiteCon.execute(sql);
    var o = POS.SQLiteCon.lastInsertId();
    measure(Time1, " - -UUUUUU");
    }

     */
    var iterator = function it(i) {
        if (i < 100) {
            var Time1 = getNow();
            var sql = "insert into BONE (Type, Qty) values ('OOO', 4)";
            $.when(POS.SQLiteCon.execute(sql)).then(function () {
                $.when(POS.SQLiteCon.lastInsertId("BONE_ID", "BONE")).then(function () {
                    measure(Time1, " - -UUUUUU");
                    iterator(i + 1);
                    return;
                });
            });

        } else {
            return;
        }
    };
    iterator(0);

}

CBonTransaction.prototype.cancelBon = function (id, reasonId) {
    /*privMan.enablePrivilege (privList);*/
    // Write Start Entry with User and POS information
    var defret = jQuery.Deferred();
    var CBonTransactionClass = this;
    var sql = "UPDATE BON SET Cancelled = " + reasonId + ", Type = 'CAN' " +
        ", Exported = 0 WHERE BON_ID = " + id;
    $.when(POS.SQLiteCon.execute(sql)).done(function () {
        $.when(CBonTransactionClass.closeBon(id, 'CAN')).done(function () {
            defret.resolve();
        });
    });
    return defret.promise();
}

CBonTransaction.prototype.addEntry = function (id, entry) {
    /*privMan.enablePrivilege (privList);*/
    // Write Start Entry with User and POS information
    var d = new Date();

    var text1 = entry.text1 == null ? "NULL" : "'" + entry.text1 + "'";
    var text2 = entry.text2 == null ? "NULL" : "'" + entry.text2 + "'";

    var sql = "INSERT INTO BONE " +
        "(BON_ID, Type, Qty, Amount, Amount_Unit, Foreign_ID, Reference_BONE_ID, " +
        "TS, Text1, Text2, Unit, Cancelled, ReplacedBy_BONE_ID, " +
        "Interaction) VALUES " +
        "( " + id + ", '" + entry.type + "', " +
        (entry.quantity ? entry.quantity : "NULL") + ", " + entry.amount +
        ", " + (entry.unitAmount ? entry.unitAmount : "NULL") + ", " +
        entry.productId + ", " +
        (entry.reference ? entry.reference.dbid : "NULL") + ", " +
        (d / 1000).toFixed(0) + ", " + text1 + ", " + text2 +
        ",'" + entry.unit + "', 0, 0, NULL)";
    var dfd = jQuery.Deferred();
    // insertMitId statt execute + lastInsertId im then(): sonst bekamen zwei
    // gleichzeitig angelegte Zeilen dieselbe Nummer (core/sqlite.js).
    $.when(POS.SQLiteCon.insertMitId(sql, "BONE_ID", "BONE")).then(function (dbid) {
        // Set id for entry
        entry.dbid = dbid;
        // Return Bon Id
        dfd.resolve(dbid);
    });
    return dfd.promise();
}

CBonTransaction.prototype.changeVAT = function (entry, VAT) {
    /*privMan.enablePrivilege (privList);*/
    var CBonTransactionClass = this;
    var defret = $.Deferred();
    if (entry.product) {
        var sql = "UPDATE BONE set VAT = " + VAT +
            " WHERE BONE_ID = " + entry.dbid;
        var r = POS.SQLiteCon.execute(sql);
        $.when(r).done(function () {
            var r2 = CBonTransactionClass.updateLastExportedBONEId(entry.dbid);
            $.when(r2).done(function () {
                defret.resolve();
            });
        });
    } else {
        defret.resolve();
    }
    return defret.promise();
    //return this.updateLastExportedBONEId(entry.dbid);
}

CBonTransaction.prototype.changeInteraction = function (entry, interaction) {
    /*privMan.enablePrivilege (privList);*/
    var CBonTransactionClass = this;
    var defret = $.Deferred();
    if (entry.product) {
        var sql = "UPDATE BONE set Interaction = '" + interaction +
            "' WHERE BONE_ID = " + entry.dbid;
        var r = POS.SQLiteCon.execute(sql);
        $.when(r).done(function () {
            var r2 = CBonTransactionClass.updateLastExportedBONEId(entry.dbid);
            $.when(r2).done(function () {
                defret.resolve();
            });
        });
    } else {
        defret.resolve();
    }
    return defret.promise();
    //this.updateLastExportedBONEId(entry.dbid);
}

CBonTransaction.prototype.changeText2 = function (entry, text2) {
    /*privMan.enablePrivilege (privList);*/
    var CBonTransactionClass = this;
    var defret = $.Deferred();
    if (entry.product) {
        var sql = "UPDATE BONE set Text2 = '" + text2 +
            "' WHERE BONE_ID = " + entry.dbid;
        var r = POS.SQLiteCon.execute(sql);
        $.when(r).done(function () {
            var r2 = CBonTransactionClass.updateLastExportedBONEId(entry.dbid);
            $.when(r2).done(function () {
                defret.resolve();
            });
        });
    } else {
        defret.resolve();
    }
    return defret.promise();
    //this.updateLastExportedBONEId(entry.dbid);
}

CBonTransaction.prototype.updateEntry = function (entry, interaction) {
    /*privMan.enablePrivilege (privList);*/
    var r4 = this.cancelEntry(entry);
    var CBonTransactionClass = this;
    var defret = $.Deferred();

    $.when(r4).done(function () {
        $.when(CBonTransactionClass.duplicateEntry(entry, interaction)).done(function () {
            var entries = CBonTransactionClass.collectSubEntries(entry);
            // Write Entry with User and POS information
            var d = new Date();
            //for (rb in entries) {
            var rbs = Object.keys(entries);
            var iterator = function it(i) {
                if (i < rbs.length) {
                    var rb = rbs[i];
                    var centry = entries[rb];
                    var text1 = centry.text1 == null ? "NULL" : "'" + centry.text1 + "'";
                    var text2 = centry.text2 == null ? "NULL" : "'" + centry.text2 + "'";
                    var sql = "UPDATE BONE set Qty = " +
                        (centry.quantity ? centry.quantity : "NULL") +
                        ", Amount = " + centry.amount + ", Amount_Unit = " +
                        (centry.unitAmount ? centry.unitAmount : "NULL") +
                        ", Foreign_ID = " + centry.productId + ", Reference_BONE_ID = " +
                        (centry.reference ? centry.reference.dbid : "NULL") + ", TS = " +
                        (d / 1000).toFixed(0) + ", Text1 = " + text1 + ", Text2 = " +
                        text2 + " WHERE BONE_ID = " + centry.dbid;
                    $.when(POS.SQLiteCon.execute(sql)).done(function () {
                        $.when(CBonTransactionClass.updateLastExportedBONEId(centry.dbid)).done(function () {
                            iterator(i + 1);
                            return;
                        });
                    });

                } else {
                    defret.resolve();
                    return;
                }
            }
            iterator(0);
        });
    });
    return defret.promise();
}

CBonTransaction.prototype.duplicateEntry = function (entry, interaction) {
    var BonTransactionClass = this;
    var defret = $.Deferred();
    /*privMan.enablePrivilege (privList);*/
    // Cancel Entry from an already checked CBonEntry element
    var oldNew = new Array();
    var entries = this.collectSubEntries(entry);
    /*
    for (rb in entries){
    var Time2 = getNow();

    var firstId = entries[rb].dbid;
    var sql = "INSERT INTO BONE (BON_ID, Type, Qty, Amount, " +
    "Amount_Unit, Foreign_ID, Reference_BONE_ID, TS, Text1, Text2, " +
    "Unit, Cancelled, ReplacedBy_BONE_ID, Interaction, VAT) " +
    "SELECT BON_ID, Type, Qty, Amount, Amount_Unit, Foreign_ID, " +
    "Reference_BONE_ID, TS, Text1, Text2, Unit, 0, " +
    "0, NULL, VAT FROM BONE " +
    "WHERE BONE_ID = " + firstId;
    POS.SQLiteCon.execute(sql);
    var secondId = POS.SQLiteCon.lastInsertId();

    sql = "UPDATE BONE set ReplacedBy_BONE_ID = " + secondId +
    ", Interaction = '" + interaction + "' WHERE BONE_ID = " + firstId;
    POS.SQLiteCon.execute(sql);
    this.updateLastExportedBONEId(firstId);

    entries[rb].dbid = secondId;
    oldNew[firstId] = secondId;
    }*/

    var rbs = Object.keys(entries);
    var def = $.Deferred();
    var iterator = function it(i) {
        if (i < rbs.length) {
            var rb = rbs[i];
            var Time2 = getNow();
            //var rb = entries[i];
            var firstId = entries[rb].dbid;
            var sql = "INSERT INTO BONE (BON_ID, Type, Qty, Amount, " +
                "Amount_Unit, Foreign_ID, Reference_BONE_ID, TS, Text1, Text2, " +
                "Unit, Cancelled, ReplacedBy_BONE_ID, Interaction, VAT) " +
                "SELECT BON_ID, Type, Qty, Amount, Amount_Unit, Foreign_ID, " +
                "Reference_BONE_ID, TS, Text1, Text2, Unit, 0, " +
                "0, NULL, VAT FROM BONE " +
                "WHERE BONE_ID = " + firstId;
            // Nummer ohne Luecke zum INSERT holen (insertMitId, core/sqlite.js).
            $.when(POS.SQLiteCon.insertMitId(sql, "BONE_ID", "BONE")).then(function (secondId) {
                sql = "UPDATE BONE set ReplacedBy_BONE_ID = " + secondId +
                    ", Interaction = '" + interaction + "' WHERE BONE_ID = " + firstId;
                $.when(POS.SQLiteCon.execute(sql)).done(function () {
                    $.when(BonTransactionClass.updateLastExportedBONEId(firstId)).done(function () {
                        entries[rb].dbid = secondId;
                        oldNew[firstId] = secondId;
                        iterator(i + 1);
                        return;
                    });
                });
            });
        } else {
            def.resolve();
            return;
        }
    }
    iterator(0);

    $.when(def).done(function () {
        var firstIds = Object.keys(oldNew);
        var iterator2 = function it2(i) {
            if (i < firstIds.length) {
                var firstId = firstIds[i];
                //for (firstId in oldNew) {
                secondId = oldNew[firstId];
                sql = "UPDATE BONE set Reference_BONE_ID = " + secondId +
                    " WHERE Reference_BONE_ID = " + firstId + " AND Cancelled = 0";
                $.when(POS.SQLiteCon.execute(sql)).done(function () {
                    $.when(BonTransactionClass.updateLastExportedBONEId(firstId)).done(function () {
                        iterator2(i + 1);
                        return;
                    });
                });
            } else {
                defret.resolve();
                return;
            }
        }
        iterator2(0);

    });
    return defret.promise();
}

CBonTransaction.prototype.cancelEntry = function (entry, interaction) {
    /*privMan.enablePrivilege (privList);*/
    var d = new Date();
    var defret = $.Deferred();
    var BonTransactionClass = this;

    if (typeof interaction == "undefined")
        interaction = "CAN";

    // Cancel Entry from an already checked CBonEntry element
    var entries = this.collectSubEntries(entry);
    //for (rb in entries) {
    var rbs = Object.keys(entries);
    var iterator = function it(i) {
        if (i < rbs.length) {
            var rb = rbs[i];
            var sql = "UPDATE BONE SET Cancelled = " + (d / 1000).toFixed(0) +
                ", Interaction = '" + interaction + "' WHERE BONE_ID = " + entries[rb].dbid;
            $.when(POS.SQLiteCon.execute(sql)).done(function () {
                $.when(BonTransactionClass.updateLastExportedBONEId(entries[rb].dbid)).done(function () {
                    iterator(i + 1);
                    return;
                });
            });
        } else {
            defret.resolve();
            return;
        }
    }
    iterator(0);
    return defret.promise();
}

CBonTransaction.prototype.updatePurchaser = function (purchaserId) {
    /*privMan.enablePrivilege (privList);*/
    var BonTransactionClass = this;
    var defret = $.Deferred();
    var sql = "SELECT MAX(BONE_ID) AS LastPAY FROM BONE WHERE Type = 'PAY'";
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        var maxBonE = rows[0].LastPAY;
        //r.free();
        $.when(BonTransactionClass.getPurchaserName(purchaserId)).then(function (userName) {
            sql = "UPDATE BONE SET Text2 = '" + userName + "' WHERE BONE_ID = " + maxBonE;
            $.when(POS.SQLiteCon.execute(sql)).done(function () {
                $.when(BonTransactionClass.updateLastExportedBONEId(maxBonE)).done(function () {
                    defret.resolve();
                });
            });
        });
    });
    return defret.promise();
}

CBonTransaction.prototype.getPurchaserName = function (purchaserId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT Name FROM U WHERE Login = " + purchaserId;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        var userName = rows[0].Name;
        //r.free();
        dfd.resolve(userName);
        //return userName;
    });
    return dfd.promise();
}

CBonTransaction.prototype.getPurchaserNameFromBONE = function (bonId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT Text2 FROM BONE WHERE BON_ID = " + bonId +
        " AND Type = 'PAY' AND Text1 = 'PPU' AND Cancelled = 0";
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        var userName = rows[0].Text2;
        //r.free();
        dfd.resolve(userName);
        //return userName;
    });
    return dfd.promise();
}

CBonTransaction.prototype.uncancelEntry = function (entry, creditCardId, payAmount, extCreditRef) {
    /*privMan.enablePrivilege (privList);*/
    // Cancel Entry from an already checked CBonEntry element
    var defret = $.Deferred();
    var entries = this.collectSubEntries(entry);
    var BonTransactionClass = this;
    //for (rb in entries) {
    var rbs = Object.keys(entries);
    var iterator = function it(i) {
        if (i < rbs.length) {
            var rb = rbs[i];
            var sql = "UPDATE BONE SET Cancelled = 0" +
                ", Interaction = NULL, Amount = " + payAmount + ", Foreign_ID = " +
                (extCreditRef ? extCreditRef : 0);
            if (creditCardId)
                sql += ", Text2 = '" + creditCardId + "'";
            sql += " WHERE BONE_ID = " + entries[rb].dbid;
            var r = POS.SQLiteCon.execute(sql);
            log.add(4, "Info", "Validated entry with BONE_ID = " + entries[rb].dbid, "");
            $.when(r).done(function () {
                var boneId = parseFloat(entries[rb].dbid);
                var r3 = BonTransactionClass.updateLastExportedBONEId(boneId)
                    $.when(r3).done(function () {
                        iterator(i + 1);
                        return;
                    });
            });
        } else {
            defret.resolve();
            return;
        }
    }
    iterator(0);

    return defret.promise();
}

CBonTransaction.prototype.collectSubEntries = function (entry) {
    var entries = new Array();
    entries.push(entry);
    for (var rb in entry.referencedBy) {
        entries.push(entry.referencedBy[rb]);
    }
    return entries;
}

function CRebateData(name, scale, timeGrid, start, end, id) {
    this.scale = scale;
    this.timeGrid = timeGrid.split("\n");
    if (this.timeGrid.length < 7) { //dann kein \n
        this.timeGrid = [];
        timeGrid = timeGrid.replace('\n', '');
        for (var i = 0; i < 7; i++) {
            this.timeGrid.push(timeGrid.substring(i * 48, i * 48 + 48));
        }
    }
    for (var h in this.timeGrid) {
        this.timeGrid[h] = this.timeGrid[h].split("");
    }
    for (h in this.timeGrid) {
        for (var i in this.timeGrid[h]) {
            this.timeGrid[h][i] = this.timeGrid[h][i] == "-" ? false : true;
        }
    }
    this.start = parseFloat(start);
    this.end = parseFloat(end);

    var idForBarcodeRebate = "666";

    var nameParts = name.split("#");
    this.name = nameParts[nameParts.length - 1];

    if (this.name.slice(0, 8) == "ONLYCUST") {
        this.name = this.name.slice(8, this.name.length);
        this.onlyCust = true;
    } else
        this.onlyCust = false;

    var barc = name.slice(0, idForBarcodeRebate.length);

    if (barc == idForBarcodeRebate)
        this.fromBarcode = name;
    else
        this.fromBarcode = 0;
}

function CProductData(nodeId) {
    /*privMan.enablePrivilege (privList);*/
    var BonTransactionClass = this;
    var sql = "SELECT Type, Unit, EAN, Text1, Text2, VAT, VATGroup, Amount_Unit, " +
        "Max_Rebate, AllowComma, CorrectedAmount FROM PROD WHERE " +
        "PROD_ID = " + nodeId;
    var dfd = jQuery.Deferred();
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        BonTransactionClass.valid = rows.length == 1;
        if (!BonTransactionClass.valid) {
            dfd.resolve(BonTransactionClass);
            //r.free();
            return;
        }

        BonTransactionClass.prodId = nodeId;
        BonTransactionClass.vat = Number(rows[0].VAT);
        BonTransactionClass.vatCorrected = -1;
        BonTransactionClass.vatGroup = rows[0].VATGroup;
        BonTransactionClass.vatShortcut = "-";
        BonTransactionClass.ean = rows[0].EAN;
        BonTransactionClass.unit = rows[0].Unit;
        BonTransactionClass.price = fix2Decimals(rows[0].Amount_Unit);
        BonTransactionClass.correctedPrice = rows[0].CorrectedAmount;
        if (isNaN(BonTransactionClass.correctedPrice))
            BonTransactionClass.correctedPrice = 0;
        BonTransactionClass.text1 = rows[0].Text1;
        BonTransactionClass.text2 = rows[0].Text2;
        BonTransactionClass.allowComma = rows[0].AllowComma;
        BonTransactionClass.generic = rows[0].Type == "GEN";
        BonTransactionClass.rebateMargin = rows[0].Max_Rebate; // User Right

        sql = "SELECT PRODZREB.REB_ID AS REB_ID, Name, TimeGrid, Start, End " +
            "FROM PRODZREB INNER JOIN REB ON " +
            "PRODZREB.REB_ID = REB.REB_ID WHERE PRODZREB.PROD_ID = " + nodeId +
            " ORDER BY PRODZREB.REB_ID";

        $.when(POS.SQLiteCon.execute(sql)).then(function (rows2) {
            BonTransactionClass.rebates = new Array();

            // BonTransactionClass  comparison before the rebates is for products that NEVER should get a rebate
            if (BonTransactionClass.ean != "201615230705590" && BonTransactionClass.text1 != "Dahlien statt 2,9" && BonTransactionClass.text1 != "Kapring.statt 2,5") {
                for (var i = 0; i < rows2.length; i++) {
                    BonTransactionClass.rebates[rows2[i].REB_ID] =
                        new CRebateData(rows2[i].Name, null,
                            rows2[i].TimeGrid, rows2[i].Start,
                            rows2[i].End);
                    //r2.moveNext();
                }

                sql = "SELECT REBS.REB_ID, Qty, Rebate FROM REBS INNER JOIN PRODZREB ON " +
                    "REBS.REB_ID = PRODZREB.REB_ID WHERE PRODZREB.PROD_ID = " + nodeId +
                    " ORDER BY PRODZREB.REB_ID, Qty";
                $.when(POS.SQLiteCon.execute(sql)).then(function (rows3) {
                    var rebId = -1;
                    for (i = 0; i < rows3.length; i++) {
                        if (rebId != rows3[i].REB_ID) {
                            rebId = rows3[i].REB_ID;
                            BonTransactionClass.rebates[rebId].scale = new Array();
                        }
                        BonTransactionClass.rebates[rebId].scale[parseFloat(rows3[i].Qty)] =
                            parseFloat(rows3[i].Rebate);
                        //r3.moveNext();
                    }
                    //r3.free();


                    //r.free();
                    //r2.free();
                    dfd.resolve(BonTransactionClass);
                });
            }
        });
    });
    return dfd.promise();
}

CBonTransaction.prototype.getAllRebates = function () {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var rebates = new Array();

    var sql = "SELECT REB_ID, Name, TimeGrid, Start, End FROM REB ORDER BY REB_ID";

    /*    var sql = "SELECT PRODZREB.REB_ID AS REB_ID, Name, TimeGrid, Start, End " +
    "FROM PRODZREB INNER JOIN REB ON PRODZREB.REB_ID = REB.REB_ID " +
    "ORDER BY PRODZREB.REB_ID";*/

    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        for (var i = 0; i < rows.length; i++) {
            rebates[rows[i].REB_ID] =
                new CRebateData(rows[i].Name, new Array(),
                    rows[i].TimeGrid, rows[i].Start,
                    rows[i].End);
            //r.moveNext();
        }

        sql = "SELECT REB_ID, Qty, Rebate FROM REBS ORDER BY REB_ID, Qty";

        /*    sql = "SELECT REBS.REB_ID, Qty, Rebate FROM REBS INNER JOIN PRODZREB ON " +
        "REBS.REB_ID = PRODZREB.REB_ID ORDER BY PRODZREB.REB_ID, Qty";*/

        $.when(POS.SQLiteCon.execute(sql)).then(function (rows3) {
            var rebId = -1;
            for (i = 0; i < rows3.length; i++) {
                if (rebId != rows3[i].REB_ID) {
                    rebId = rows3[i].REB_ID;
                    if (rebates[rebId] && rebates[rebId].scale) {
                        rebates[rebId].scale = new Array();
                    } else {
                        console.log("REBID null");
                    }

                }
                if (rebates[rebId] && rebates[rebId].scale) {
                    rebates[rebId].scale[parseFloat(rows3[i].Qty)] =
                        parseFloat(rows3[i].Rebate);
                }
                //r3.moveNext();
            }

            //r.free();
            //r3.free();
            dfd.resolve(rebates);
            //return rebates;
        });
    });
    return dfd.promise();
}

CBonTransaction.prototype.getProductData = function (nodeId) {
    /*var Prod = new CProductData(nodeId);
    return Prod;    */
    return new CProductData(nodeId);
}

function CFreeProductData(nodeId) {

    var defret = jQuery.Deferred();
    /*privMan.enablePrivilege (privList);*/
    var sql = "SELECT Text1, Text2, VAT FROM FREEPROD WHERE FREEPROD_ID = " +
        nodeId;
    var BonTransactionClass = this;
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        BonTransactionClass.valid = rows.length == 1;
        if (!BonTransactionClass.valid) {
            //r.free();
            defret.resolve(BonTransactionClass);
            return;
        }

        BonTransactionClass.text1 = rows[0].Text1;
        BonTransactionClass.text2 = rows[0].Text2;
        BonTransactionClass.vat = Number(rows[0].VAT);
        BonTransactionClass.vatCorrected = -1;
        BonTransactionClass.vatGroup = null;
        BonTransactionClass.vatShortcut = "-";
        defret.resolve(BonTransactionClass);
        //r.free();
    });
    return defret.promise();
}

CBonTransaction.prototype.getFreeProductData = function (nodeId) {
    var Prod = new CFreeProductData(nodeId);
    return Prod;
}

function CPaydownData(vat) {
    this.text1 = "Anzahlung " + remAmericanComma(vat * 100) + "% MwSt.";
    this.text2 = "";
    this.vat = vat;
    this.vatCorrected = -1;
    this.vatGroup = null;
    this.vatShortcut = "-";
}

CBonTransaction.prototype.getPaydownData = function (vat) {
    var Prod = new CPaydownData(vat);
    return Prod;
}

CBonTransaction.prototype.loadBonInfos = function (id) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var parameters = new Array();

    var sql = "SELECT End, U_ID, CUST_ID FROM BON WHERE BON_ID = " + id +
        " AND POS_ID = " + POS.POSId;
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        //if (r.recordCount() != 1)
        if (rows.length != 1) {
            //r.free();
            //return null;
            dfd.resolve(null);
            return;
        }

        parameters["User"] = rows[0].U_ID;
        parameters["DateTime"] = new Date(rows[0].End * 1000);
        parameters["Customer"] = rows[0].CUST_ID;

        //r.free();
        dfd.resolve(parameters);
        //return parameters;
    });
    return dfd.promise();
}

CBonTransaction.prototype.load = function (id) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var def = jQuery.Deferred();
    var sql = "SELECT BON_ID, Closed, Start, End, POS_ID, U_ID, UName, " +
        "Cancelled FROM BON WHERE BON_ID = " + id + " AND POS_ID = " + POS.POSId;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (r.recordCount() != 1)
        if (rows.length != 1) {
            //r.free();
            dfd.resolve(null);
            //return null;
            return;
        }

        var sql2 = "SELECT BONE_ID, Type, Qty, Amount, " +
            "Amount_Unit, Foreign_ID, Reference_BONE_ID, TS, " +
            "Text1, Text2, Unit, Cancelled, VAT, Interaction FROM BONE " +
            "WHERE (Cancelled = 0 OR (Type = 'POS' AND Interaction = 'CAN')) " +
            " AND BONE.BON_ID = " + rows[0].BON_ID;
        var r2 = POS.SQLiteCon.execute(sql2);
        $.when(r2).then(function (rows2) {
            var loadedBon = new Array();
            /*
            for (var i = 0; i < rows2.length; i++){
            var Product = null;
            if (rows2[i].Type == "POS" ||
            rows2[i].Type == "REC" ||
            rows2[i].Type == "FPR" ||
            rows2[i].Type == "ARB")
            Product = rows2[i].Foreign_ID;

            loadedBon[i] = new CBonEntry(i,
            rows2[i].Type,
            rows2[i].Unit,
            rows2[i].Qty,
            rows2[i].Text1,
            rows2[i].Text2,
            rows2[i].Reference_BONE_ID,
            rows2[i].Amount,
            rows2[i].Amount_Unit,
            Product,
            parseFloat(rows2[i].VAT));

            loadedBon[i].productId = rows2[i].Foreign_ID;
            loadedBon[i].cancelled = rows2[i].Cancelled != 0;
            loadedBon[i].dbid = rows2[i].BONE_ID;
            loadedBon[i].interaction = rows2[i].Interaction;
            if (loadedBon[i].product)
            loadedBon[i].product.vatCorrected = parseFloat(rows2[i].VAT);

            //r2.moveNext();
            }
             */
            var iterator = function it(i) {
                if (i < rows2.length) {
                    var Product = null;
                    if (rows2[i].Type == "POS" ||
                        rows2[i].Type == "REC" ||
                        rows2[i].Type == "FPR" ||
                        rows2[i].Type == "ARB")
                        Product = rows2[i].Foreign_ID;

                    loadedBon[i] = new CBonEntry(i,
                            rows2[i].Type,
                            rows2[i].Unit,
                            rows2[i].Qty,
                            rows2[i].Text1,
                            rows2[i].Text2,
                            rows2[i].Reference_BONE_ID,
                            rows2[i].Amount,
                            rows2[i].Amount_Unit,
                            Product,
                            parseFloat(rows2[i].VAT));
                    $.when(loadedBon[i].defreturn).done(function (c) {
                        loadedBon[i].productId = rows2[i].Foreign_ID;
                        loadedBon[i].cancelled = rows2[i].Cancelled != 0;
                        loadedBon[i].dbid = rows2[i].BONE_ID;
                        loadedBon[i].interaction = rows2[i].Interaction;
                        if (loadedBon[i].product)
                            loadedBon[i].product.vatCorrected = parseFloat(rows2[i].VAT);
                        iterator(i + 1);
                        return;
                    });
                } else {
                    def.resolve();
                    return;
                }
            }
            iterator(0);

            $.when(def).done(function () {
                // Enter Reference Ids
                for (i = 0; i < loadedBon.length; i++) {
                    if (!loadedBon[i].reference)
                        continue;
                    var refId = loadedBon[i].reference;
                    for (var s = 0; s < loadedBon.length; s++) {
                        if (loadedBon[s].dbid == refId) {
                            loadedBon[s].referencedBy[i] = loadedBon[i];
                            loadedBon[i].reference = loadedBon[s];
                            break;
                        }
                    }
                }

                /* r.free();
                r2.free();
                return loadedBon; */
                dfd.resolve(loadedBon);
            });
        });
    });
    return dfd.promise();
}

CBonTransaction.prototype.getCustomerRebate = function (id) {
    var dfd = jQuery.Deferred();
    /*privMan.enablePrivilege (privList);*/
    var sql = "SELECT Rebate FROM CUST WHERE CUST_ID = " + id;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (r.recordCount() != 1)
        if (rows.length != 1) {
            //r.free();
            dfd.resolve(0);
            return;
            //return 0;
        }

        var rebate = rows[0].Rebate;
        //r.free();
        dfd.resolve(rebate);
        //return rebate;
    });
    return dfd.promise();
}

CBonTransaction.prototype.getPaymentId = function (shortcut) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT PAY_ID FROM PAY WHERE Shortcut = '" + shortcut + "'";
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        var paymentId = parseInt(rows[0].PAY_ID);

        //r.free();
        dfd.resolve(paymentId);
        //return paymentId;
    });
    return dfd.promise();
}

CBonTransaction.prototype.getPaymentInfo = function (id) {
    var dfd = jQuery.Deferred();
    /*privMan.enablePrivilege (privList);*/
    var sql = "SELECT OpenBox, CashDiscount, Name, Shortcut, Auto, " +
        "ReturnMoneyScreen FROM PAY " +
        "WHERE PAY_ID = " + id;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        if (rows.length != 1) {
            //r.free();
            //return 0;
            dfd.resolve(0);
            return;
        }

        var ret = new Array();
        ret["openBox"] = parseInt(rows[0].OpenBox);
        ret["cashDiscount"] = parseInt(rows[0].CashDiscount);
        ret["name"] = rows[0].Name;
        var shortcut = rows[0].Shortcut;
        var shortcutParts = shortcut.split("#");
        ret["shortcut"] = shortcutParts[0];
        ret["cardtype"] = (shortcutParts.length > 1) ? shortcutParts[1] : null;
        ret["auto"] = parseInt(rows[0].Auto);
        ret["returnMoneyScreen"] = parseInt(rows[0].ReturnMoneyScreen);

        dfd.resolve(ret);
        /*r.free();
        return ret; */
    });
    return dfd.promise();
}

CBonTransaction.prototype.addMPREntry = function (bonId, prodId, prodQty) {
    /*privMan.enablePrivilege (privList);*/

    var sql = "SELECT Unit, Amount_Unit, Text1, Text2, VAT FROM PROD WHERE " +
        "PROD_ID = " + prodId;

    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        var unit = rows[0].Unit;
        var amountUnit = rows[0].Amount_Unit;
        var text1 = rows[0].Text1;
        var text2 = rows[0].Text2;
        var VAT = rows[0].VAT;

        var text1DB = text1 == null ? "NULL" : "'" + text1 + "'";
        var text2DB = text2 == null ? "NULL" : "'" + text2 + "'";

        var d = new Date();
        var totalAmount = parseFloat(prodQty) * parseFloat(amountUnit);

        //r.free();

        sql = "INSERT INTO BONE (BON_ID, Type, Qty, Amount, " +
            "Amount_Unit, Foreign_ID, Reference_BONE_ID, TS, Text1, Text2, " +
            "Unit, Cancelled, ReplacedBy_BONE_ID, Interaction, VAT) " +
            "VALUES (" + bonId + ", 'MPR', " + prodQty + ", " + totalAmount +
            ", " + amountUnit + ", " + prodId + ", NULL, " + (d / 1000).toFixed(0) +
            ", " + text1DB + ", " + text2DB + ", '" + unit + "', 0, " +
            "0, NULL, " + VAT + ")";

        POS.SQLiteCon.execute(sql);
    });
}

CBonTransaction.prototype.getLastBFC = function (bunchId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT BON_ID FROM BONE WHERE Foreign_ID = " + bunchId +
        " AND Type = 'BFC' ORDER BY BON_ID DESC";

    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        if (rows.length > 0) {
            var bonId = rows[0].BON_ID;
        } else {
            bonId = 0;
        }

        /*r.free();
        return bonId;*/
        dfd.resolve(bonId);
    });
    return dfd.promise();
}

CBonTransaction.prototype.separateBunchEntry = function (lastBFCBon, bonId) {
    /*privMan.enablePrivilege (privList);*/
    var BonTransactionClass = this;
    var defret = $.Deferred();
    var sql = "INSERT INTO BONE (BON_ID, Type, Qty, Amount, " +
        "Amount_Unit, Foreign_ID, Reference_BONE_ID, TS, Text1, Text2, " +
        "Unit, Cancelled, ReplacedBy_BONE_ID, Interaction, VAT) " +
        "SELECT BON_ID, Type, Qty, Amount, Amount_Unit, Foreign_ID, " +
        "Reference_BONE_ID, TS, Text1, Text2, Unit, 0, " +
        "0, NULL, VAT FROM BONE WHERE BON_ID = " + lastBFCBon + " AND " +
        "Type = 'BFC'";

    // Nummer ohne Luecke zum INSERT holen (insertMitId, core/sqlite.js).
    var r2 = POS.SQLiteCon.insertMitId(sql, "BONE_ID", "BONE");
    $.when(r2).then(function (id) {
        var d = new Date();

        sql = "UPDATE BONE SET BON_ID = " + bonId + ", Type = 'BFS', TS = " +
            (d / 1000).toFixed(0) + " WHERE BONE_ID = " + id;
        var r3 = BonTransactionClass.updateLastExportedBONEId(id);
        $.when(r3).done(function () {
            var r4 = POS.SQLiteCon.execute(sql);
            $.when(r4).done(function () {
                defret.resolve();
            });
        });
    });
    return defret.promise();
}

CBonTransaction.prototype.copyLastBFC = function (lastBFCBon, bonId) {
    /*privMan.enablePrivilege (privList);*/

    var sql = "SELECT BONE_ID, Reference_BONE_ID, Type FROM BONE WHERE BON_ID = " + lastBFCBon +
        " AND Cancelled = 0 AND Type != 'BFS'  ORDER BY BONE_ID ASC";
    var defret = $.Deferred();
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        var d = new Date();
        var timestamp = (d / 1000).toFixed(0);

        //for (var i = 0; i < rows.length - 1; i++) {
        var iterator = function it(i) {
            if (i < rows.length - 1) {
                var oldBoneId = rows[i].BONE_ID;

                sql = "INSERT INTO BONE (BON_ID, Type, Qty, Amount, " +
                    "Amount_Unit, Foreign_ID, Reference_BONE_ID, TS, Text1, Text2, " +
                    "Unit, Cancelled, ReplacedBy_BONE_ID, Interaction, VAT) " +
                    "SELECT " + bonId + ", Type, Qty, Amount, Amount_Unit, Foreign_ID, " +
                    "Reference_BONE_ID, " + timestamp + ", Text1, Text2, Unit, 0, " +
                    "0, NULL, VAT FROM BONE WHERE BONE_ID = " + oldBoneId;

                $.when(POS.SQLiteCon.execute(sql)).then(function () {
                    $.when(POS.SQLiteCon.lastInsertId("BONE_ID", "BONE")).then(function (boneId) {
                        var typ = rows[i].Type;
                        if (typ == "MRB" || typ == "ARB") {
                            var refBoneId = rows[i].Reference_BONE_ID;
                            var newRefId = boneId - (oldBoneId - refBoneId);
                            sql = "UPDATE BONE set Reference_BONE_ID = " + newRefId + " where BONE_ID = " + boneId;
                            $.when(POS.SQLiteCon.execute(sql)).done(function () {
                                iterator(i + 1);
                                return;
                            });

                        } else {
                            iterator(i + 1);
                            return;
                        }
                    });
                });
                //r.moveNext();
            } else {
                defret.resolve();
                return;
            }
        }
        iterator(0);
        //r.free();
    });
    return defret.promise();
}

CBonTransaction.prototype.addBunch = function (bonId, sum, bunchType) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var qties = new Array();
    var prods = new Array();
    var stocks = new Array();

    var sql = "SELECT MAX(PROD_ID) AS MX FROM PROD";

    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        var NewProdId = Number(rows[0].MX) + 1;
        //r.free();

        if (NewProdId < 1000000000)
            NewProdId = 1000000000;

        if (bunchType == "Geschenkstrau&szlig;" || bunchType == "Geschenktopf" ||
            bunchType == "Biedermeierstrau&szlig;")
            var prodType = "BFF";
        else
            prodType = "NPP";

        sql = "INSERT INTO PROD " +
            "(PROD_ID, Type, Unit, EAN, Text1, Text2, VAT, Amount_Unit, " +
            "Max_Rebate, AllowComma, VATGroup, ChangeGroup, CorrectedAmount" +
            ") VALUES (" + NewProdId + ", '" + prodType + "', 'Stk', '0', '" + bunchType + "', NULL, " +
            POS.VATStandard + ", " + sum + ", 0, 0, NULL, NULL, 0)";
        $.when(POS.SQLiteCon.execute(sql)).then(function () {
            sql = "REPLACE INTO PRODSTOCK (PROD_ID, InStock, ReturnStock, ReceivedStock, Exported) " +
                "VALUES (" + NewProdId + ", 1, 0, 0, 0)";
            $.when(POS.SQLiteCon.execute(sql)).then(function () {
                var d = new Date();
                var timestamp = (d / 1000).toFixed(0);

                var newId = "99" + NewProdId.toString();

                sql = "UPDATE PROD SET EAN = '" + newId + "' WHERE PROD_ID = " + NewProdId;

                $.when(POS.SQLiteCon.execute(sql)).then(function () {
                    if (bunchType == "Geschenkstrau&szlig;" || bunchType == "Geschenktopf" ||
                        bunchType == "Biedermeierstrau&szlig;")
                        var shortType = "BFC";
                    else
                        shortType = "NPP";

                    sql = "UPDATE BON SET Closed = -1, Type = '" + shortType + "', End = " + timestamp +
                        ", Exported = 0 WHERE BON_ID = " + bonId;

                    $.when(POS.SQLiteCon.execute(sql)).then(function () {
                        sql = "INSERT INTO BONE (BON_ID, Type, Qty, Amount, " +
                            "Amount_Unit, Foreign_ID, Reference_BONE_ID, TS, Text1, Text2, " +
                            "Unit, Cancelled, ReplacedBy_BONE_ID, Interaction, VAT) " +
                            "VALUES (" + bonId + ", '" + shortType + "', 1, " + sum + ", " + sum + ", " +
                            NewProdId + ", NULL, " + timestamp + ", '" + bunchType + "', NULL, 'Stk', " +
                            "0, 0, NULL, " + POS.VATStandard + ")";
                        $.when(POS.SQLiteCon.execute(sql)).then(function () {
                            dfd.resolve(newId);
                        });
                        //return newId;
                    });
                });
            });
        });
    });
    return dfd.promise();
}

CBonTransaction.prototype.addBunchFromMaster = function (bonId, currentBon, sum, bunchType, qty, newId) {

    var dfd = jQuery.Deferred();
    var qties = new Array();
    var prods = new Array();
    var stocks = new Array();

    var NewProdId = newId.substring(2);

    if (bunchType == "Geschenkstrau&szlig;" || bunchType == "Geschenktopf" ||
        bunchType == "Biedermeierstrau&szlig;")
        var prodType = "BFF";
    else
        prodType = "NPP";

    sql = "INSERT INTO PROD " +
        "(PROD_ID, Type, Unit, EAN, Text1, Text2, VAT, Amount_Unit, " +
        "Max_Rebate, AllowComma, VATGroup, ChangeGroup, CorrectedAmount" +
        ") VALUES (" + NewProdId + ", '" + prodType + "', 'Stk', '" + newId + "', '" + bunchType + "', NULL, " +
        POS.VATStandard + ", " + sum + ", 0, 0, NULL, NULL, 0)";

    $.when(POS.SQLiteCon.execute(sql)).then(function () {

        var d = new Date();
        var timestamp = (d / 1000).toFixed(0);

        if (bunchType == "Geschenkstrau&szlig;" || bunchType == "Geschenktopf" ||
            bunchType == "Biedermeierstrau&szlig;")
            var shortType = "BFC";
        else
            shortType = "NPP";

        sql = "UPDATE BON SET Closed = -1, Type = '" + shortType + "', End = " + timestamp +
            ", Exported = 0 WHERE BON_ID = " + bonId;

        /*$.when(POS.SQLiteCon.execute(sql)).then(function () {
        sql = "INSERT INTO BONE (BON_ID, Type, Qty, Amount, " +
        "Amount_Unit, Foreign_ID, Reference_BONE_ID, TS, Text1, Text2, " +
        "Unit, Cancelled, ReplacedBy_BONE_ID, Interaction, VAT) " +
        "VALUES (" + bonId + ", '" + shortType + "', 1, " + sum + ", " + sum + ", " +
        NewProdId + ", NULL, " + timestamp + ", '" + bunchType + "', NULL, 'Stk', " +
        "0, 0, NULL, " + POS.VATStandard + ")";*/
        $.when(POS.SQLiteCon.execute(sql)).then(function () {
            var iterator = function it(i) {
                if (i < currentBon.length) {
                    /*var sql = "INSERT INTO BONE " +
                    "(BON_ID, Type, Qty, Amount, Amount_Unit, Foreign_ID, Reference_BONE_ID, " +
                    "TS, Text1, Text2, Unit, Cancelled, ReplacedBy_BONE_ID, " +
                    "Interaction,VAT) VALUES " +
                    "( " + bonId + ", 'POS', " +
                    (currentBon[i].quantity ? currentBon[i].quantity : "NULL") + ", " + currentBon[i].amount +
                    ", " + (currentBon[i].unitAmount ? currentBon[i].unitAmount : "NULL") + ", " +
                    currentBon[i].productId + ", NULL, " +
                    timestamp + ", '" + currentBon[i].text1 + "', '" + currentBon[i].text2 +
                    "','" + currentBon[i].unit + "', 0, 0, NULL,"+currentBon[i].product.vat+")";*/
                    var sql = "INSERT INTO BONE " +
                        "(BON_ID, Type, Qty, Amount, Amount_Unit, Foreign_ID, Reference_BONE_ID, " +
                        "TS, Text1, Text2, Unit, Cancelled, ReplacedBy_BONE_ID, " +
                        "Interaction,VAT) VALUES " +
                        "( " + bonId + ",'" + currentBon[i].Type + "', " + currentBon[i].Qty + ", " + currentBon[i].Amount +
                        ", " + currentBon[i].Amount_Unit + ", " + currentBon[i].Foreign_ID + ", NULL, " +
                        timestamp + ", '" + currentBon[i].Text1 + "', '" + (currentBon[i].Text2 ? currentBon[i].Text2 : '') +
                        "','" + currentBon[i].Unit + "', 0, 0, NULL," + currentBon[i].VAT + ")";
                    $.when(POS.SQLiteCon.execute(sql)).then(function () {
                        iterator(i + 1);
                    });

                } else {
                    dfd.resolve();
                }
            };
            iterator(0);
        });
        //return newId;
        //	});
    });

    return dfd.promise();
}

/*
CBonTransaction.prototype.getBFCfromSlave = function(bunchId) {

var dfd = jQuery.Deferred();
var ts = (Date.now() / 1000 | 0) - 1209600; //14*24*60*60; //14 Tage zurück
var sql = "SELECT MIN(BONE.Foreign_ID) as ID from BONE where TS>" + ts + " and BONE.Foreign_ID>'1000000000'";
var r = POS.SQLiteCon.execute(sql);
$.when(r).then(function(rows) {
var sql1 = "SELECT PROD_ID FROM PROD WHERE PROD_ID>=" + rows[0].ID + " ORDER BY PROD_ID ASC";
var r1 = POS.SQLiteCon.execute(sql1);
$.when(r1).then(function(rows) {
dfd.resolve(rows);
});
});
return dfd.promise();
}
 */
CBonTransaction.prototype.getBFCsforSlave = function (prodids) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();

    var dataarray = [];
    try {
        var iterator = function it(i) {
            if (i < prodids.length) {
                if (i === (prodids.length - 1)) {
                    var operator = '>=';
                } else {
                    operator = '=';
                }
                var sql = "SELECT * from (SELECT * FROM PROD WHERE PROD_ID " + operator + prodids[i] + "  and PROD_ID>1000000000 order by PROD_ID desc limit 50) order by PROD_ID asc";
                $.when(POS.SQLiteCon.execute(sql)).then(function (prod) {
                    var iterator2 = function it(j) {
                        if (j < prod.length) {
                            var sql1 = "SELECT *,U.U_ID as UserID,BONE.Type as Type from BONE left join BON on BONE.BON_ID=BON.BON_ID left join U on BON.U_ID=U.Login where BONE.BON_ID=(SELECT BON_ID FROM BONE WHERE Foreign_ID=" + prod[j].PROD_ID + " and Type IS NOT 'POS')";
                            $.when(POS.SQLiteCon.execute(sql1)).then(function (bone) {
                                if (prod && prod.length > 0 && bone && bone.length > 0) {
                                    /*    var BFFBon = [];
                                    for (var j = 0; j < bone.length; j++) {
                                    var b = {
                                    "Type": bone[j].Type,
                                    "Qty": bone[j].Qty,
                                    "Amount": bone[j].Amount,
                                    "Amount_Unit": bone[j].Amount_Unit,
                                    "Foreign_ID": bone[j].Foreign_ID,
                                    "Text1": bone[j].Text1,
                                    "Text2": bone[j].Text2,
                                    "Unit": bone[j].Unit,
                                    "VAT": bone[j].VAT
                                    }
                                    }*/
                                    //  bone.Type = bone.BoneType;
                                    //                                  log.add(2, "Info", "getBFCsforSlave: ", JSON.stringify(bone));
                                    dataarray.push({
                                        "userid": bone[0].UserID,
                                        "bon": bone,
                                        "prod": {
                                            "sum": prod[j].Amount_Unit,
                                            "bunchtype": prod[j].Text1,
                                            "qty": 0,
                                            "barcode": prod[j].EAN
                                        }
                                    });
                                };
                                iterator2(j + 1);
                            });
                        } else {
                            iterator(i + 1);
                        }
                    }
                    iterator2(0);
                });
            } else {
                dfd.resolve(dataarray);
            }
        }
        iterator(0);
    } catch (e) {
        log.add(2, "Error", "getBFCsforSlave: ", e);
        dfd.resolve([]);
    }
    return dfd.promise();
}

CBonTransaction.prototype.remakeInStock = function (bonId, mode) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var qties = new Array();
    var prods = new Array();
    var stocksIn = new Array();
    var stocksReturn = new Array();

    /*var sql = "SELECT Qty, InStock, ReturnStock, PROD.PROD_ID, BONE.Type FROM BONE " +
    "INNER JOIN PROD ON BONE.Foreign_ID = PROD.PROD_ID " +
    "INNER JOIN PRODSTOCK ON PRODSTOCK.PROD_ID = PROD.PROD_ID " +
    "WHERE BONE.BON_ID = " +
    bonId + " AND BONE.Cancelled = 0 AND (BONE.Type = 'POS'";
    switch (mode) {
    case "BFS":
    sql += " OR BONE.Type = 'BFS')";
    break;
    case "MPR":
    sql += " OR BONE.Type = 'MPR')";
    break;
    default:
    sql += ")";
    }*/

    var sql = "SELECT Qty, PROD.PROD_ID, BONE.Type FROM BONE " +
        "INNER JOIN PROD ON BONE.Foreign_ID = PROD.PROD_ID " +
        "WHERE BONE.BON_ID = " +
        bonId + " AND BONE.Cancelled = 0 AND (BONE.Type = 'POS'";
    switch (mode) {
    case "BFS":
        sql += " OR BONE.Type = 'BFS')";
        break;
    case "MPR":
        sql += " OR BONE.Type = 'MPR')";
        break;
    default:
        sql += ")";
    }

    $.when(POS.SQLiteCon.execute(sql)).then(function (p) {

        if (p.length > 0) {
            sql = "SELECT InStock, ReturnStock,PROD_ID FROM PRODSTOCK where PROD_ID = " + p[0].PROD_ID;

            for (var j = 1; j < p.length; j++) {
                sql += " OR PROD_ID = " + p[j].PROD_ID;
            }

            $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {

                if (!rows) {
                    dfd.resolve();
                    return;
                }
                for (var i = 0; i < rows.length; i++) {
                    var qty = 0; //parseFloat(rows[i].Qty);
                    var inStock = parseFloat(rows[i].InStock);
                    var returnStock = parseFloat(rows[i].ReturnStock);
                    var prodId = rows[i].PROD_ID;
                    var bonEType = ""; //rows[i].Type;
                    var found = false;
                    for (var j = 0; j < p.length; j++) {
                        if (prodId == p[j].PROD_ID) {
                            qty += p[j].Qty;
                            bonEType = p[j].Type;
                            //break;
                        }
                    }

                    /*for (var j = 0; j < prods.length; j++) {
                    if (prods[j] == prodId) {
                    qties[j] += qty;
                    found = true;
                    break;
                    }
                    }*/

                    //if (!found) {
                    prods[prods.length] = prodId;
                    if (bonEType == "BFS" || bonEType == "MPR")
                        qties[qties.length] = -qty;
                    else
                        qties[qties.length] = qty;
                    stocksIn[stocksIn.length] = inStock;
                    stocksReturn[stocksReturn.length] = returnStock;
                    //}

                    //r.moveNext();
                }

                //r.free();
                var iterator = function it(i) {
                    if (i < prods.length) {
                        //for (i = 0; i < prods.length; i++) {
                        var newInStock = stocksIn[i];
                        var newReturnStock = stocksReturn[i];

                        switch (mode) {
                        case "BFS":
                            newInStock = stocksIn[i] + qties[i];
                            break;
                        case "CAN":
                            newInStock = stocksIn[i] + qties[i];
                            break;
                        case "EXP":
                            newInStock = stocksIn[i] - qties[i];
                            newReturnStock = stocksReturn[i] + qties[i];
                            break;
                        case "IEX":
                            newInStock = stocksIn[i] + qties[i];
                            newReturnStock = stocksReturn[i] - qties[i];
                            break;
                        case "DRC":
                            newInStock = stocksIn[i];
                            newReturnStock = stocksReturn[i] - qties[i];
                            if (newReturnStock < 0)
                                newReturnStock = 0;
                            break;
                        default: // cases "BFC", "MPR" & "CLS"
                            newInStock = stocksIn[i] - qties[i];
                        }

                        sql = "UPDATE PRODSTOCK SET InStock = " + newInStock + ", ReturnStock = " +
                            newReturnStock + ", Exported = 0 WHERE PROD_ID = " + prods[i];

                        $.when(POS.SQLiteCon.execute(sql)).then(function () {
                            iterator(i + 1);
                        })
                    } else {
                        dfd.resolve();
                    }
                }
                iterator(0);
            }, function (reason) { //reject
                var text = "Lagerstand konnte nicht &uumlbertragen werden. Zum Weiterarbeiten OK dr&uumlcken!!";
                //  POS.message.show(text, "warning", "OK");
                dfd.resolve();
            });
        } else {
            dfd.resolve();
        }
    });
    return dfd.promise();
}

CBonTransaction.prototype.inStockInput = function (bonId) {
    /*privMan.enablePrivilege (privList);*/
    var defret = jQuery.Deferred();
    var BonTransactionClass = this;
    /*var sql = "SELECT BONE_ID, Qty, Amount_Unit, Foreign_ID, Cancelled, InStock" +
    " FROM BONE INNER JOIN PRODSTOCK ON BONE.Foreign_ID = PRODSTOCK.PROD_ID " +
    "WHERE BONE.BON_ID = " + bonId + " AND BONE.Type = 'POS' AND Cancelled = 0";*/

    var sql = "SELECT BONE_ID, Qty, Amount_Unit,Foreign_ID,Cancelled FROM BONE WHERE BONE.BON_ID = " + bonId + " AND BONE.Type = 'POS' AND Cancelled = 0";

    //$.when(POS.SQLiteCon.execute(sql)).then(function (bone) {

    /*sql = "SELECT PROD_ID, InStock FROM PRODSTOCK where PROD_ID = " +bone[0].PROD_ID;

    for (var j=1; j<p.length;j++){
    sql += " OR PROD_ID = "+bone[j].PROD_ID;
    }*/

    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        var updated = new Array();

        /*for (var i = 0; i < rows.length; i++){*/
        var iterator = function it(i) {
            if (i < rows.length) {
                var bonEId = rows[i].BONE_ID;
                var amountUnit = rows[i].Amount_Unit;
                var newInStock = parseFloat(rows[i].Qty);
                var prodId = rows[i].Foreign_ID;

                sql = "SELECT InStock FROM PRODSTOCK WHERE PROD_ID = " + prodId;

                var r2 = POS.SQLiteCon.execute(sql);
                $.when(r2).then(function (rows2) {

                    if (rows2 && rows2[0]) {
                        var oldInStock = rows2[0].InStock;
                    } else {
                        oldInStock = -100;
                    }

                    sql = "INSERT INTO BONE (BON_ID, Type, Qty, Amount, " +
                        "Amount_Unit, Foreign_ID, Reference_BONE_ID, TS, Text1, Text2, " +
                        "Unit, Cancelled, ReplacedBy_BONE_ID, Interaction, VAT) " +
                        "SELECT BON_ID, Type, Qty, Amount, Amount_Unit, Foreign_ID, " +
                        "Reference_BONE_ID, TS, Text1, Text2, Unit, Cancelled, " +
                        "ReplacedBy_BONE_ID, Interaction, VAT FROM BONE WHERE BONE_ID = " + bonEId;

                    var r10 = POS.SQLiteCon.execute(sql);
                    $.when(r10).then(function () {
                        var v = POS.SQLiteCon.lastInsertId("BONE_ID", "BONE");
                        $.when(v).then(function (idBonE) {
                            var newAmount = parseFloat(amountUnit) * parseFloat(oldInStock);
                            var d = new Date();

                            sql = "UPDATE BONE SET Type = 'SIN', Qty = " + oldInStock +
                                ", Amount = " + newAmount + ", TS = " + (d / 1000).toFixed(0) +
                                " WHERE BONE_ID = " + idBonE;
                            var r11 = POS.SQLiteCon.execute(sql);
                            $.when(r11).then(function () {
                                var r13 = BonTransactionClass.updateLastExportedBONEId(idBonE);
                                $.when(r13).then(function () {
                                    var found = false;

                                    for (var j = 0; j < updated.length; j++) {
                                        if (updated[j] == prodId) {
                                            newInStock += parseFloat(oldInStock);
                                            found = true;
                                        }
                                    }

                                    if (!found)
                                        updated[updated.length] = prodId;

                                    sql = "UPDATE PRODSTOCK SET InStock = " + newInStock + ", Exported = 0" +
                                        " WHERE PROD_ID = " + prodId;

                                    var r12 = POS.SQLiteCon.execute(sql);
                                    $.when(r12).then(function () {
                                        iterator(i + 1);
                                        return;
                                    });
                                });

                            });

                            //r.moveNext();
                        });
                    });
                });
            } else {
                defret.resolve();
                return;
            }
        };
        iterator(0);

    });
    //});
    return defret.promise();
    /*r.free();
    r2.free();*/
}

CBonTransaction.prototype.isProductInStock = function (currentBonId, productId, quantity, dbid) {
    var BonTransactionClass = this;
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT BONE_ID, Qty, Cancelled FROM BONE WHERE BON_ID = " +
        currentBonId + " AND Foreign_ID = " + productId;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        var accumQty = 0;

        for (var i = 0; i < rows.length; i++) {
            if (dbid && rows[i].BONE_ID == dbid)
                continue;

            if (rows[i].Cancelled == 0)
                accumQty += parseFloat(rows[i].Qty);

            //r.moveNext();
        }

        var r13 = BonTransactionClass.getInStock(productId);
        $.when(r13).then(function (qtyInStock) {
            if (qtyInStock - accumQty - quantity < 0)
                dfd.resolve(false);
            //return false;
            else
                dfd.resolve(true);
            //return true;

        });
    });
    return dfd.promise();
}

CBonTransaction.prototype.getInStock = function (productId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT InStock FROM PRODSTOCK WHERE PROD_ID = " + productId;
    //log.add(1, "Error", "", 'here');
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {

        //if (r.recordCount)
        if (rows && rows[0] && rows.length > 0) {
            //log.add(1, "Error", "", rows);
            var inStock = rows[0].InStock;
            //r.free();
            dfd.resolve(inStock);
            //return parseFloat(inStock);
        } else {
            //r.free();
            //eturn null;
            log.add(1, "Error", "nothing in stock or no result", -100);
            dfd.resolve(-100);
        }
    });
    return dfd.promise();
}

CBonTransaction.prototype.getCustomerData = function (custId) {
    var parameters = new Array();
    var dfd = jQuery.Deferred();

    if (!custId) {
        parameters["cardNumber"] = "__________________________";
        parameters["firstName"] = "__________________________";
        parameters["surname"] = "";
        parameters["address"] = "__________________________";
        parameters["zip"] = "_____";
        parameters["city"] = "____________________";
        parameters["telephone"] = "__________________________";
        parameters["email"] = "__________________________";
        dfd.resolve(parameters);
        return dfd.promise();
    }

    /*privMan.enablePrivilege (privList);*/

    var parameters = new Array();

    var sql = "SELECT Barcode, FirstName, Surname, Address, ZIP, City, Telephone, Email, BlueId FROM CUST " +
        "WHERE CUST_ID = " + custId;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        if (rows.length != 1) {
            /* r.free();
            return null;*/
            parameters["cardNumber"] = custId;
            dfd.resolve(parameters);
            return;
        }

        parameters["cardNumber"] = rows[0].Barcode;
        parameters["firstName"] = rows[0].FirstName;
        parameters["surname"] = rows[0].Surname;
        parameters["address"] = rows[0].Address;
        parameters["zip"] = rows[0].ZIP;
        parameters["city"] = rows[0].City;
        parameters["telephone"] = rows[0].Telephone;
        parameters["email"] = rows[0].Email;

        //r.free();
        //return parameters;
        dfd.resolve(parameters);
    });
    return dfd.promise();
}

CBonTransaction.prototype.createCustomerData = function (EAN) {
    var parameters = new Array();
    var dfd = jQuery.Deferred();
    var sql = "SELECT MAX(CUST_ID) as ID FROM CUST";

    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        var id = parseInt(rows[0].ID);
        id = id + 1;
        var sql1 = "INSERT INTO CUST " +
            "(CUST_ID,Rebate,Title,FirstName,Surname,Address,ZIP,City,Country,Telephone,Fax,Email,BlueId,Barcode) " +
            "VALUES (" + id + ",'','','','','','','','','','','','1','" + EAN + "')";
        var r = POS.SQLiteCon.execute(sql1);
        $.when(r).then(function () {
            dfd.resolve();
        });
    });
    return dfd.promise();
}

CBonTransaction.prototype.updateCustomerBon = function (bonId, custId) {
    /*privMan.enablePrivilege (privList);*/

    var sql = "UPDATE BON SET CUST_ID = " + custId +
        ", Exported = 0 WHERE BON_ID = " + bonId;

    POS.SQLiteCon.execute(sql);
}

CBonTransaction.prototype.isBonStillNew = function (id) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    if (!id) {
        dfd.resolve(true);
        return;
        //return true;
    }
    var sql = "SELECT Type FROM BON WHERE BON_ID = " + id;

    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (! r.recordCount())
        if (rows.length < 1) {
            //r.free();
            dfd.resolve(false);
            return;
            //return false;
        }

        var type = rows[0].Type;
        //r.free();

        if (type == "NEW") {
            dfd.resolve(true);
            //return true;
        } else {
            dfd.resolve(false);
            //return false;
        }
    });
    return dfd.promise();
}

CBonTransaction.prototype.addDeliveryBon = function (timestamp) {
    /*privMan.enablePrivilege (privList);*/

    // Write Start Entry with User and POS information

    var sql = "INSERT INTO BON " +
        "(Closed, Start, End, POS_ID, U_ID, UName, Cancelled, Type, CUST_ID, Exported) " +
        "VALUES (-1, " + timestamp + ", 0, " + POS.POSId +
        ", NULL, NULL, 0, 'DLV', NULL, 0)";

    var dfd = jQuery.Deferred();
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function () {
        //dfd.resolve();
        var r2 = POS.SQLiteCon.lastInsertId();
        $.when(r2).then(function (id) {
            dfd.resolve(id);
            //return POS.SQLiteCon.lastInsertId();
        });
    });
    return dfd.promise();

}

CBonTransaction.prototype.closeDeliveryBon = function (idBon) {
    /*privMan.enablePrivilege (privList);*/

    var d = new Date();

    var sql = "UPDATE BON SET Closed = -1, End = " + (d / 1000).toFixed(0) +
        ", Exported = 0 WHERE BON_ID = " + idBon;

    POS.SQLiteCon.execute(sql);
}

CBonTransaction.prototype.addDeliveryEntry = function (timestamp, bonId, elements) {
    var prodId = elements[1];
    var barcode = elements[3];
    var quantity = elements[4];
    var unitAmount = elements[5];
    var amount = parseFloat(unitAmount) * parseFloat(quantity);
    var wholesalePrice = elements[6];

    /*privMan.enablePrivilege (privList);*/

    var sql = "SELECT Text1, Text2, Unit, VAT FROM PROD WHERE PROD_ID = " + prodId;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        if (rows.length != 1) {
            //r.free();
            return;
        }

        var text1DB = rows[0].Text1;
        var text2DB = rows[0].Text2;
        var unitDB = rows[0].Unit;
        var VATDB = rows[0].VAT;

        var text1DB = text1DB == null ? "NULL" : "'" + text1DB + "'";
        var text2DB = text2DB == null ? "NULL" : "'" + text2DB + "'";

        //r.free();

        sql = "INSERT INTO BONE " +
            "(BON_ID, Type, Qty, Amount, Amount_Unit, Foreign_ID, Reference_BONE_ID, " +
            "TS, Text1, Text2, Unit, Cancelled, ReplacedBy_BONE_ID, " +
            "Interaction, VAT, WholesaleAmount) VALUES " +
            "( " + bonId + ", 'POS', " + quantity + ", " + amount + ", " +
            unitAmount + ", " + prodId + ", NULL, " + timestamp + ", " +
            text1DB + ", " + text2DB + ",'" + unitDB + "', 0, 0, NULL, " +
            VATDB + ", " + wholesalePrice + ")";

        POS.SQLiteCon.execute(sql);
    });
}

CBonTransaction.prototype.addProdFreePrice = function (prodId, priceId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT MAX(PROD_ID) AS MX FROM PROD";
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        var newProdId = parseFloat(rows[0].MX) + 1;

        //r.free();

        sql = "INSERT INTO PROD (PROD_ID, Type, Unit, EAN, Text1, Text2, VAT, " +
            "Amount_Unit, Max_Rebate, AllowComma, VATGroup, ChangeGroup, " +
            "CorrectedAmount) SELECT " + newProdId + ", Type, Unit, EAN, Text1, Text2, VAT, " +
            "Amount_Unit, Max_Rebate, AllowComma, VATGroup, ChangeGroup, " +
            "CorrectedAmount FROM PROD WHERE PROD_ID = " + prodId;
        var r2 = POS.SQLiteCon.execute(sql); // Tippfehler-Fix: war OS.SQLiteCon (ReferenceError; Funktion hat aktuell keine Aufrufer - Totcode-Kandidat)
        $.when(r2).then(function () {
            sql = "UPDATE PROD SET Amount_Unit = " + priceId + " WHERE PROD_ID = " + newProdId;
            var r3 = POS.SQLiteCon.execute(sql);
            $.when(r3).then(function () {
                //return newProdId;
                dfd.resolve(newProdId);
            });
        });
    });
    return dfd.promise();
}

CBonTransaction.prototype.getUserParamsFromBon = function (bonId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT U_ID, UName FROM BON WHERE BON_ID = " + bonId;

    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        var userParams = new Array("Name", "Login");
        if (rows.length > 0) {
            userParams["Name"] = rows[0].UName;
            userParams["Login"] = rows[0].U_ID;
        }
        dfd.resolve(userParams);
        //r.free();
        //return userParams;
    });
    return dfd.promise();
}

CBonTransaction.prototype.updateBonOwner = function (bonId, userLogin, userName) {
    /*privMan.enablePrivilege (privList);*/

    var sql = "UPDATE BON SET U_ID = " + userLogin + ", UName = '" + userName +
        "' WHERE BON_ID = " + bonId;
    return POS.SQLiteCon.execute(sql);
}

CBonTransaction.prototype.updateClosedField = function (bonId, value) {
    /*privMan.enablePrivilege (privList);*/

    var sql = "UPDATE BON SET Closed = " + value + " WHERE BON_ID = " + bonId + " AND POS_ID = " + POS.POSId;
    POS.SQLiteCon.execute(sql);
}

CBonTransaction.prototype.getAdditionalBunchWork = function () {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT PROD_ID FROM PROD WHERE EAN = 'VTFLORIST'";
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        var prodId = rows[0].PROD_ID;

        //r.free();
        dfd.resolve(prodId);
        //return prodId;
    });
    return dfd.promise();
}

CBonTransaction.prototype.getLastPaymentDetails = function (bonId) {
    var payDetails = new Array("type", "ts", "payAmount", "retAmount", "boneId");
    var dfd = jQuery.Deferred();
    /*privMan.enablePrivilege (privList);*/

    var sql = "SELECT Text1, Text2, TS, Amount, BONE_ID FROM BONE WHERE BON_ID = " + bonId +
        " AND Type = 'PAY' AND Cancelled = 0 ORDER BY BONE_ID DESC LIMIT 1";
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        payDetails["type"] = rows[0].Text1;
        payDetails["changed"] = rows[0].Text2;
        payDetails["ts"] = rows[0].TS;
        payDetails["payAmount"] = parseFloat(rows[0].Amount);
        payDetails["boneId"] = parseFloat(rows[0].BONE_ID);

        sql = "SELECT Amount FROM BONE WHERE BONE_ID = " + (payDetails["boneId"] + 1) +
            " AND Type = 'RET' AND Cancelled = 0";
        var r2 = POS.SQLiteCon.execute(sql);
        $.when(r2).then(function (rows2) {
            //if (r.recordCount())
            if (rows2.length > 0)
                payDetails["retAmount"] = parseFloat(rows2[0].Amount);
            else
                payDetails["retAmount"] = 0;

            //r.free();
            dfd.resolve(payDetails);
            //return payDetails;
        });
    });
    return dfd.promise();
}

CBonTransaction.prototype.getLastUserPayment = function (userLogin) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT BON_ID FROM BON WHERE U_ID = " + userLogin +
        " AND Type = 'CLS' AND Cancelled = 0 ORDER BY BON_ID DESC LIMIT 1";
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (r.recordCount())
        if (rows.length > 0)
            var lastBonId = rows[0].BON_ID;
        else
            lastBonId = null;

        /*r.free();

        return lastBonId;*/
        dfd.resolve(lastBonId);
    });
    return dfd.promise();
}

CBonTransaction.prototype.updatePaymentEntry = function (boneId, paymentAmount, returnAmount) {
    /*privMan.enablePrivilege (privList);*/
    var defret = $.Deferred();
    var me = this;
    var sql = "UPDATE BONE SET Amount = " + paymentAmount + ", Text2 = 'CHD' WHERE BONE_ID = " + boneId;
    $.when(POS.SQLiteCon.execute(sql)).then(function () {
        $.when(me.updateLastExportedBONEId(boneId)).then(function () {
            sql = "UPDATE BONE SET Amount = " + returnAmount + " WHERE BONE_ID = " + (boneId + 1);
            $.when(POS.SQLiteCon.execute(sql)).then(function () {
                defret.resolve();
            });
        });
    });
    return defret.promise();
}

CBonTransaction.prototype.isBKClosed = function () {
    /*privMan.enablePrivilege (privList);*/

    var dfd = jQuery.Deferred();
    var sql = "SELECT MAX(BON_ID) AS MAXPOP FROM BON WHERE Type = 'POP'";
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (r.recordCount())
        if (rows.length > 0)
            var bonPOPId = rows[0].MAXPOP;
        else
            bonPOPId = 0;

        sql = "SELECT BON_ID, Type FROM BON WHERE BON_ID > " + bonPOPId +
            " AND Type IN('BKC', 'BKD') AND Cancelled = 0";
        var r2 = POS.SQLiteCon.execute(sql);
        $.when(r2).then(function (rows2) {
            var debitCardsClosed = false;
            var creditCardsClosed = false;

            for (var i = 0; i < rows2.length; i++) {
                var bonType = rows2[i].Type;
                switch (bonType) {
                case "BKC":
                    creditCardsClosed = true;
                    break;
                case "BKD":
                    debitCardsClosed = true;
                    break;
                }
                //r.moveNext();
            }

            //r.free();

            if (debitCardsClosed) // && creditCardsClosed)
                //return true;
                dfd.resolve(true);
            else
                dfd.resolve(false);
            //return false;
        });
    });
    return dfd.promise();
}

CBonTransaction.prototype.getTotalCashed = function (idBon) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT Type, Amount, Cancelled FROM BONE WHERE BON_ID = " + idBon;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        var sumTotal = 0;

        for (var i = 0; i < rows.length; i++) {
            var type = rows[i].Type;

            if (rows[i].Cancelled == 0 &&
                type != "PAY" && type != "RET" && type != "BFS") {
                sumTotal += parseFloat(rows[i].Amount);
            }

            //r.moveNext();
        }

        //.free();
        dfd.resolve(sumTotal);
        //return sumTotal;
    });
    return dfd.promise();
}

CBonTransaction.prototype.copyBonPos = function (oldBon, newBon) {
    /*privMan.enablePrivilege (privList);*/
    var BonTransactionClass = this;
    var defret = $.Deferred();

    var sql = "SELECT BONE_ID FROM BONE WHERE BON_ID = " + oldBon +
        " AND Cancelled = 0 AND Type != 'PAY' AND Type != 'RET' ORDER BY BONE_ID ASC";

    var def = $.Deferred();
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        var d = new Date();
        var timestamp = (d / 1000).toFixed(0);
        /*
        for (var i = 0; i < rows.length; i++){
        sql = "INSERT INTO BONE (BON_ID, Type, Qty, Amount, " +
        "Amount_Unit, Foreign_ID, Reference_BONE_ID, TS, Text1, Text2, " +
        "Unit, Cancelled, ReplacedBy_BONE_ID, Interaction, VAT) " +
        "SELECT " + newBon + ", Type, Qty, Amount, Amount_Unit, Foreign_ID, " +
        "Reference_BONE_ID, " + timestamp + ", Text1, Text2, Unit, 0, " +
        "0, NULL, VAT FROM BONE WHERE BONE_ID = " + rows[i].BONE_ID;

        POS.SQLiteCon.execute(sql);

        //r.moveNext();
        }
         */
        var iterator = function it(i) {
            if (i < rows.length) {
                sql = "INSERT INTO BONE (BON_ID, Type, Qty, Amount, " +
                    "Amount_Unit, Foreign_ID, Reference_BONE_ID, TS, Text1, Text2, " +
                    "Unit, Cancelled, ReplacedBy_BONE_ID, Interaction, VAT) " +
                    "SELECT " + newBon + ", Type, Qty, Amount, Amount_Unit, Foreign_ID, " +
                    "Reference_BONE_ID, " + timestamp + ", Text1, Text2, Unit, 0, " +
                    "0, NULL, VAT FROM BONE WHERE BONE_ID = " + rows[i].BONE_ID;

                $.when(POS.SQLiteCon.execute(sql)).then(function () {

                    iterator(i + 1);
                    return;
                });
            } else {
                def.resolve();
                return;
            }
        }
        iterator(0);

        // we still have to update internal bone references
        $.when(def).then(function () {
            try {
                sql = "SELECT BONE_ID, Reference_BONE_ID FROM BONE WHERE BON_ID = " + newBon +
                    " AND Reference_BONE_ID > 0";

                $.when(POS.SQLiteCon.execute(sql)).then(function (rows2) {
                    /*for (var i = 0; i < rows.length; i++){
                    var boneId = rows[i].BONE_ID;
                    var refBoneId = rows[i].Reference_BONE_ID;

                    sql = "SELECT BONE_ID FROM BONE WHERE Reference_BONE_ID = " + refBoneId +
                    " AND BON_ID = " + oldBon;
                    var r2 = POS.SQLiteCon.execute(sql);
                    var oldBoneId = r2.getColumnByName("BONE_ID");
                    r2.free();

                    var diff = parseInt(oldBoneId) - parseInt(refBoneId);
                    var newDiff = parseInt(boneId) - diff;

                    sql = "UPDATE BONE SET Reference_BONE_ID = " + newDiff + " WHERE BONE_ID = " + boneId;
                    POS.SQLiteCon.execute(sql);
                    this.updateLastExportedBONEId(boneId);
                    }*/
                    var iterator2 = function it2(i) {
                        if (i < rows2.length) {
                            var boneId = rows2[i].BONE_ID;
                            var refBoneId = rows2[i].Reference_BONE_ID;

                            sql = "SELECT BONE_ID FROM BONE WHERE Reference_BONE_ID = " + refBoneId +
                                " AND BON_ID = " + oldBon;

                            $.when(POS.SQLiteCon.execute(sql)).then(function (rows3) {
                                var oldBoneId = rows3[i].BONE_ID;
                                //r2.free();
                                var diff = parseInt(oldBoneId) - parseInt(refBoneId);
                                var newDiff = parseInt(boneId) - diff;
                                sql = "UPDATE BONE SET Reference_BONE_ID = " + newDiff + " WHERE BONE_ID = " + boneId;
                                $.when(POS.SQLiteCon.execute(sql)).then(function () {
                                    $.when(BonTransactionClass.updateLastExportedBONEId(boneId)).then(function () {
                                        iterator2(i + 1);
                                        return;
                                    });
                                });
                            },
                                function (err) {
                                throw new Error();
                            });
                        } else {
                            defret.resolve();
                            return;
                        }
                    }
                    iterator2(0);
                },
                    function (err) {
                    throw new Error();
                });
            } catch (e) {
                log.add(2, "Error", "Could not update references for new copied bon " + newBon, e);
            }
        });

        //r.free();
    });
    return defret.promise();
}

CBonTransaction.prototype.addReturnMoney = function (bonId, amount) {
    /*privMan.enablePrivilege (privList);*/

    var d = new Date();
    var timestamp = (d / 1000).toFixed(0);

    var sql = "INSERT INTO BONE (BON_ID, Type, Qty, Amount, " +
        "Amount_Unit, Foreign_ID, Reference_BONE_ID, TS, Text1, Text2, " +
        "Unit, Cancelled, ReplacedBy_BONE_ID, Interaction, VAT) " +
        "VALUES (" + bonId + ", 'RET', NULL, " + amount + ", NULL, 0, NULL, " +
        timestamp + ", 'BAR', 'CAN', 'NIL', 0, 0, NULL, NULL)";

    POS.SQLiteCon.execute(sql);
}

CBonTransaction.prototype.getLastCreditBalanceTS = function () {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT Start FROM BON WHERE Type = 'BKC' ORDER BY BON_ID DESC LIMIT 1";
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (r.recordCount())
        if (rows.length > 0)
            var lastBalanceTS = rows[0].Start;
        else {
            var d = new Date();
            lastBalanceTS = (d / 1000).toFixed(0) - 43200; // Estimation: 12 hours before now
        }

        //r.free();
        dfd.resolve(lastBalanceTS);
        //return lastBalanceTS;
    });
    return dfd.promise();
}

CBonTransaction.prototype.isStillPaydown = function (bonId) {
    /*privMan.enablePrivilege (privList);*/

    var sql = "SELECT Type, Closed FROM BON WHERE BON_ID = " + bonId;
    var dfd = jQuery.Deferred();
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (! r.recordCount())
        if (rows.length < 1) {
            dfd.resolve(false);
            return;
            //return false;
        }

        var type = rows[0].Type;
        var closed = parseFloat(rows[0].Closed);
        //r.free();

        if (type == "CLS" && closed == -3)
            dfd.resolve(true);
        //return true;
        else
            dfd.resolve(false);
        //return false;
    });
    return dfd.promise();
}

CBonTransaction.prototype.makeBonCopy = function (bonId, newBonId) {
    /*privMan.enablePrivilege (privList);*/

    var defret = jQuery.Deferred();
    var sql = "SELECT BONE_ID FROM BONE WHERE BON_ID = " + bonId +
        " AND Cancelled = 0 ORDER BY BONE_ID ASC";

    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        var d = new Date();
        var timestamp = (d / 1000).toFixed(0);

        //for (var i = 0; i < rows.length; i++) {
        var iterator = function it(i) {
            if (i < rows.length) {
                sql = "INSERT INTO BONE (BON_ID, Type, Qty, Amount, " +
                    "Amount_Unit, Foreign_ID, Reference_BONE_ID, TS, Text1, Text2, " +
                    "Unit, Cancelled, ReplacedBy_BONE_ID, Interaction, VAT) " +
                    "SELECT " + newBonId + ", Type, Qty, Amount, Amount_Unit, Foreign_ID, " +
                    "Reference_BONE_ID, " + timestamp + ", Text1, Text2, Unit, 0, " +
                    "0, NULL, VAT FROM BONE WHERE BONE_ID = " + rows[i].BONE_ID;

                $.when(POS.SQLiteCon.execute(sql)).then(function () {
                    iterator(i + 1);
                });
                //r.moveNext();
            } else {
                defret.resolve();
            }
        };
        iterator(0);
        //r.free();
    });
    return defret.promise();
}

CBonTransaction.prototype.setPaydowns = function (oldBonId, newBonId) {
    /*privMan.enablePrivilege (privList);*/
    var BonTransactionClass = this;
    var defret = $.Deferred();
    var d = new Date();
    var timestamp = (d / 1000).toFixed(0);

    var sql = "UPDATE BONE set Interaction = 'PDN', Foreign_ID = " + oldBonId +
        " WHERE BON_ID = " + newBonId + " AND Cancelled = 0 AND Type IN('PAY', 'RET')";
    $.when(POS.SQLiteCon.execute(sql)).then(function () {
        sql = "UPDATE BONE set Interaction = 'PDN' WHERE BON_ID = " + newBonId + " AND Cancelled = 0 AND Type IN('POS')";
        $.when(POS.SQLiteCon.execute(sql)).then(function () {
            //auch update von POS, damit in Auswertung nicht 2x berücksichtigt.
            sql = "SELECT MIN(BONE_ID) AS Min FROM BONE WHERE BON_ID = " + newBonId;
            $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
                //if (r.recordCount())
                if (rows.length > 0) {
                    var minBoneId = rows[0].Min;
                    $.when(BonTransactionClass.updateLastExportedBONEId(minBoneId)).then(function () {
                        defret.resolve();
                    });
                } else {
                    defret.resolve();
                }
            });
        });
    });
    //r.free();
    return defret.promise();
}

CBonTransaction.prototype.getPosREGId = function (bonId) {

    var dfd = jQuery.Deferred();
    if (!bonId)
        return null;

    /*privMan.enablePrivilege (privList);*/

    var sql = "SELECT ReceiptID FROM BONREG WHERE BON_ID = " + bonId + " LIMIT 1";

    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        //if (!r.recordCount())
        if (rows.length < 1)
            var posBonId = false;
        else
            posBonId = rows[0].ReceiptID;

        //r.free();
        dfd.resolve(posBonId);
        //return posBonId;
    });
    return dfd.promise();
}

CBonTransaction.prototype.getPosBonId = function (bonId) {

    var dfd = jQuery.Deferred();
    if (!bonId)
        return null;

    /*privMan.enablePrivilege (privList);*/

    var sql = "SELECT POSBON_ID FROM POSBON WHERE BON_ID = " + bonId + " LIMIT 1";

    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        //if (!r.recordCount())
        if (rows.length < 1)
            var posBonId = false;
        else
            posBonId = rows[0].POSBON_ID;

        //r.free();
        dfd.resolve(posBonId);
        //return posBonId;
    });
    return dfd.promise();
}

CBonTransaction.prototype.getBonIdFromPosBon = function (posBonId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT BON_ID FROM POSBON WHERE POSBON_ID = " + posBonId + " LIMIT 1";
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        var posBonId = rows[0].BON_ID;
        //r.free();
        dfd.resolve(posBonId);
        //return posBonId;
    });
    return dfd.promise();
}

CBonTransaction.prototype.isPostCancelled = function (bonId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = $.Deferred();
    var sql = "SELECT Cancelled FROM BON WHERE BON_ID = " + bonId +
        " AND POS_ID = " + POS.POSId + " AND Type = 'CAN' LIMIT 1";
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        //if (r.recordCount() != 1)
        if (rows.length != 1) {
            //r.free();
            //return false;
            dfd.resolve(false);
            return;
        }

        var cancelled = rows[0].Cancelled;
        //r.free();

        if (parseFloat(cancelled) < -1)
            dfd.resolve(true);
        //return true;
        else
            dfd.resolve(false);
        //return false;
    });
    return dfd.promise();
}

CBonTransaction.prototype.getPaydownBonInUse = function (bonId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT BONE.BON_ID FROM BON INNER JOIN BONE ON BON.BON_ID = BONE.BON_ID " +
        "WHERE BON.Type = 'NEW' AND BONE.Foreign_ID = " + bonId + " AND POS_ID = " + POS.POSId;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (! r.recordCount())
        if (rows.length < 1) {
            //r.free();
            dfd.resolve(-1);
            //return -1;
            return;
        }

        var newBonId = rows[0].BON_ID;
        //r.free();
        dfd.resolve(newBonId);
        //return newBonId;
    });
    return dfd.promise();
}

CBonTransaction.prototype.isPaydown = function (bonId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT Closed FROM BON WHERE BON_ID = " + bonId + " AND POS_ID = " + POS.POSId;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (! r.recordCount())
        if (rows.length < 1) {
            dfd.resolve(false);
            /*r.free();
            return false;*/
            return;
        }

        var closed = rows[0].Closed;
        //r.free();

        if (closed == -3) {
            //return true;
            dfd.resolve(true);
        } else {
            dfd.resolve(false);
            //return false;
        }
    });
    return dfd.promise();
}

CBonTransaction.prototype.getReferenceBill = function (bonId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT Text2 FROM BONE WHERE BON_ID = " + bonId + " AND Type = 'CDS' AND Cancelled = 0 LIMIT 1";
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (! r.recordCount())
        if (rows.length < 1) {
            dfd.resolve(false);
            /*r.free();
            return false;*/
            return;
        }

        var refBillId = parseFloat(rows[0].Text2);
        //r.free();
        //return refBillId;
        dfd.resolve(refBillId);
    });
    return dfd.promise();
}

CBonTransaction.prototype.uncancelBon = function (bonId) {
    /*privMan.enablePrivilege (privList);*/

    var sql = "UPDATE BON set Type = 'CLS', Cancelled = 0, Closed = -2 WHERE BON_ID = " + bonId;
    POS.SQLiteCon.execute(sql);
}

CBonTransaction.prototype.getCancelText = function (cancelId) {
    switch (cancelId) {
    case -2:
        return POS.lang.getText("LABELS", "TOO_MUCH_PAID").replace(/\r/g, "");
    case -3:
        return POS.lang.getText("LABELS", "CUSTOMER_PRODUCT_CHANGE").replace(/\r/g, "");
    }
}

CBonTransaction.prototype.getTSFromBonId = function (bonId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT End FROM BON WHERE BON_ID = " + bonId;
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        //if (! r.recordCount())
        if (rows.length < 1) {
            dfd.resolve(false);
            /*r.free();
            return false;*/
            return;
        }

        var ts = parseFloat(rows[0].End);
        //r.free();
        //return ts;
        dfd.resolve(ts);
    });
    return dfd.promise();
}

CBonTransaction.prototype.isBarcodeRebate = function (prodId) {
    /*privMan.enablePrivilege (privList);*/
    var BonTransactionClass = this;
    var dfd = jQuery.Deferred();
    var sql = "SELECT EAN FROM PROD WHERE PROD_ID = " + prodId;
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        //if (! r.recordCount())
        if (rows.length < 1) {
            /*r.free();
            return false;*/
            dfd.resolve(false);
            return;
        }

        var ean = rows[0].EAN;

        $.when(BonTransactionClass.checkIfRebate(ean)).then(function (val) {
            dfd.resolve(val);
        });
        //return this.checkIfRebate(ean);
    });
    return dfd.promise();
}

CBonTransaction.prototype.getCustomerIdFromBarcode = function (barcode) {
    var dfd = jQuery.Deferred();
    /*privMan.enablePrivilege (privList);*/
    var me = this;
    var sql = "SELECT CUST_ID FROM CUST WHERE Barcode = " + barcode;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (r.recordCount() != 1)
        if (rows.length < 1) {
            $.when(me.createCustomerData(barcode)).then(function () {
                $.when(me.getCustomerIdFromBarcode(barcode)).then(function (custId) {
                    dfd.resolve(custId);
                    return;
                })
            })
        } else {
            var custId = parseInt(rows[0].CUST_ID);
            /*r.free();
            return custId;*/
            dfd.resolve(custId);
        }
    });
    return dfd.promise();
}

CBonTransaction.prototype.getCustomerIdFromBon = function (bonId) {
    var dfd = jQuery.Deferred();
    /*privMan.enablePrivilege (privList);*/
    var sql = "SELECT CUST_ID FROM BON WHERE BON_ID = " + bonId;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (r.recordCount() != 1)
        if (rows.length != 1) {
            /*r.free();
            return 0;*/
            dfd.resolve(0);
            return;
        }

        var custId = parseInt(rows[0].CUST_ID);
        //r.free();
        dfd.resolve(custId);
        //return custId;
    });
    return dfd.promise();
}

CBonTransaction.prototype.updateCustomerToBon = function (bonId, custId) {
    /*privMan.enablePrivilege (privList);*/
    var sql = "UPDATE BON SET Exported = 0, CUST_ID = " + custId + " WHERE BON_ID = " + bonId;
    POS.SQLiteCon.execute(sql);
}

CBonTransaction.prototype.getPPCProduct = function () {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT PROD_ID FROM PROD WHERE EAN = 'VTPPC' and Text1 = 'Wertkarte'";
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (r.recordCount())
        if (rows.length > 0)
            var prodId = rows[0].PROD_ID;
        else
            prodId = false;

        dfd.resolve(prodId);
        /*r.free();

        return prodId;*/
    });
    return dfd.promise();
}

CBonTransaction.prototype.cancelPPCPayments = function (bonId) {
    /*privMan.enablePrivilege (privList);*/
    var BonTransactionClass = this;
    var defret = $.Deferred();

    var d = new Date();
    var ts = (d / 1000).toFixed(0);

    var sql = "UPDATE BONE SET Cancelled = " + ts + ", Interaction = 'CAN' WHERE " +
        "BON_ID = " + bonId + " AND Type = 'PAY' AND Text1 = 'PPC' AND Cancelled = 0"
        var r2 = POS.SQLiteCon.execute(sql);
    $.when(r2).then(function () {
        sql = "SELECT MIN(BONE_ID) AS Min FROM BONE WHERE BON_ID = " + bonId;
        var r = POS.SQLiteCon.execute(sql);
        $.when(r).then(function (rows) {
            //if (r.recordCount())
            if (rows.length > 0) {
                var minBoneId = rows[0].Min;
                var r3 = BonTransactionClass.updateLastExportedBONEId(minBoneId);
                $.when(r3).then(function () {
                    defret.resolve();
                });
            } else {
                defret.resolve();
            }

            //r.free();
        });
    });
    return defret.promise();
}

CBonTransaction.prototype.checkIfRebate = function (code) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT Name FROM REB WHERE Name LIKE '666%'";
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        var rebateFound = false;

        for (var i = 0; i < rows.length; i++) {
            var rebName = rows[i].Name;
            var rebParts = rebName.split("#");
            var rebBarcode = rebParts[0];
            if (rebBarcode == code) {
                rebateFound = rebBarcode;
                break;
            }
            //r.moveNext();
        }

        /*r.free();
        return rebateFound;*/
        dfd.resolve(rebateFound);
    });
    return dfd.promise();
}

CBonTransaction.prototype.checkIfSuperBon = function (cust_id, code, Entry) { //check if Rabatt Aktion
    /*privMan.enablePrivilege (privList);*/
    var me = this;
    /* if (!(cust_id)) {
    var text = "Bitte zuerst Kundennummer scannen!";
    POS.message.show(text, "warning", "OK");
    return 0;
    }*/
    var dfd = jQuery.Deferred();
    //   var sql = "SELECT * from POSysseus_Reports.CUSTEAN where REBEAN=" + code + " and CUSTEAN=" + cust_id;
    /*   var sql = "SELECT * from POSysseus_Reports.CUSTEAN where CUSTEAN=" + code;

    var callback = function (newcode) {

    if (newcode && newcode.length > 0) {
    code = newcode[0].REBEAN;
    }*/
	

	code = String(code);
	if (code && !(String(code).startsWith("66699")) && (code != "6660000000208") ){
		code = "66699000" + String(code).substring(3,8);
		
    }

    var def = jQuery.Deferred();

    var BM = POS.sessions.openSessions[POS.sessions.currentSession].BonManager;
    //var sql = "SELECT REB_ID, Name FROM REB WHERE Name LIKE
    var sql = "SELECT REB.REB_ID as REB_ID, Name, PRODZREB.PROD_ID as PROD_ID, REBS.Qty as Qty, REB.Start as Start, REB.End as End FROM REB left join PRODZREB on REB.REB_ID=PRODZREB.REB_ID left join REBS on REBS.REB_ID=REB.REB_ID WHERE Name LIKE '" + code + "%'";
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        // Gueltigkeit wie bei den automatischen Rabatten (rebateengine:
        // Start <= jetzt <= End) - sonst wirkt ein Werbe-Gutschein, sobald
        // er in REB steht (Testkasse 3.11.2026: "ab 10.11." schon am 3.11.)
        if (rows.length > 0) {
            var jetzt = new Date() / 1000;
            var gueltig = rows.filter(function (r) {
                var start = parseFloat(r.Start), ende = parseFloat(r.End);
                return !(start > jetzt) && !(ende < jetzt);
            });
            if (gueltig.length == 0) {
                var start = parseFloat(rows[0].Start);
                var text;
                if (start > jetzt) {
                    var d = new Date(start * 1000);
                    text = "Dieser Rabattcode ist erst ab " + expandInteger(d.getDate(), 2) + "." +
                        expandInteger(d.getMonth() + 1, 2) + "." + d.getFullYear() + " g&uuml;ltig!";
                } else {
                    text = "Dieser Rabattcode ist abgelaufen!";
                }
                dfd.resolve(false);
                POS.message.show(text, "warning", "OK");
                return;
            }
            rows = gueltig;
        }
        //BM.Grid.selectedRowIndex
        var bon = BM.currentBon;
        var Index = -1;
        var poscount = 0;
        if (rows[0] && rows[0].PROD_ID) { //wenn Rabattaktion vorhanden
            var iterator = function it(i) {
                if (i < bon.length) {
                    if (bon[i].productId && (bon[i].productId == rows[0].PROD_ID) && (bon[i].cancelled == false)) {
                        Index = poscount;
                        var Entry = bon[i];
                        return;
                    }
                    if (bon[i].type == "POS") {
                        poscount = poscount + 1;
                    }
                    iterator(i + 1);
                }
            }
            iterator(0);
            if (Index > -1) { // Produkt schon eingegeben markiere die Reihe
                var Grid = POS.sessions.openSessions[POS.sessions.currentSession].components.bonContainer.components.bon;
                Grid.rowSelectInt(Grid, Index);
                Grid.moveIt = true;
                def.resolve();
            } else { //gib neues Produkt dazu wie mainPos.addProd
                // let myPromise = new Promise(function (resolve) {
                //var mainPOS = POS.sessions.openSessions[POS.sessions.currentSession];
                // var parameters = [POS.sessions.currentSession, rows[0].PROD_ID, "screen"];
                //await mainPOS.addProd(null, parameters, false);
                var comp = POS.getComponentById(POS.sessions.currentSession);
                log.add(4, "Info", "Adding product " + rows[0].PROD_ID + " from Rebatescan");
                $.when(comp.BonManager.preAddEntryPOS(comp.vacuumInfoValue(comp), rows[0].PROD_ID)).then(function () {
                    def.resolve();
                });
            }
        } else if (rows.length == 0) {
            dfd.resolve(false);
            def.resolve();
            var text = "Kein Rabatt mit diesem Rabattcode bekannt!";
            POS.message.show(text, "warning", "OK");
            return;
        } else {
            def.resolve();
        }

        /*if (rows[0] && rows[0].PROD_ID && Entry) {
        if (Entry.productId != rows[0].PROD_ID) {
        dfd.resolve(false);
        var text = "Der Rabatt ist nicht für das markierte Produkt anwendbar!";
        POS.message.show(text, "warning", "OK");
        return;
        }
        }*/
        $.when(def).done(function () {
            if (rows[0] && rows[0].Qty && Entry) {
                if (rows[0].Qty > Entry.quantity) {
                    dfd.resolve(false);
                    var text = "Mindestbestellmenge ist " + rows[0].Qty + " Stück!";
                    POS.message.show(text, "warning", "OK");
                    return;
                }
            }

            var RebateBarcode = false;

            for (var i = 0; i < rows.length; i++) {
                var rebName = rows[i].Name;
                var rebParts = rebName.split("#");
                var b = rebParts[0];
                var n = rebParts[1];
                var forCust = n.slice(0, 8);
                var shortcut = b.slice(b.length - 2, b.length);

                var prefix = '';
                switch (shortcut) {
                case 'RP':
                    if (!(cust_id)) {
                        /* var text = "Bitte vor Abschluß des Bons Kundenbarcode scannen!";
                        POS.message.show(text, "warning", "OK");*/
                        //return;
                    }
                case 'SB': // Rebate in Percent
                    prefix = "RP:";
                    break;
                case 'AR':
                    if (!(cust_id)) {
                        /* var text = "Bitte vor Abschluß des Bons Kundenbarcode scannen!";
                        POS.message.show(text, "warning", "OK");*/
                        //return;
                    }
                case 'PR': //absolute Rebate -> in EUR
                    prefix = "AR:";
                    break;
                case 'TR': //Rebate in percent from Total-> in EUR
                    if (!(cust_id)) {
                        /* var text = "Bitte vor Abschluß des Bons Kundenbarcode scannen!";
                        POS.message.show(text, "warning", "OK");*/
                        //return;
                    }
                    prefix = "TR:";
                    break;
                case 'TA': //absolute Rebate from Total -> in EUR
                    if (!(cust_id)) {
                        /*  var text = "Bitte vor Abschluß des Bons Kundenbarcode scannen!";
                        POS.message.show(text, "warning", "OK");*/
                        //return;
                    }
                    prefix = "TA:";
                    break;
                default:
                    console.log('Default shortcut');
                }
                if (forCust != "ONLYCUST" || (forCust == "ONLYCUST" && cust_id))
                    RebateBarcode = prefix + rows[i].REB_ID;

                /*if ((shortcut == "SB") || (shortcut == "PR")) {
                var prefix = '';
                if (shortcut == "PR") {
                prefix = "PR:";
                }
                if (forCust != "ONLYCUST" || (forCust == "ONLYCUST" && cust_id))
                //superBon = rows[i].REB_ID;
                superBon = prefix + rows[i].REB_ID; // b.slice(0, b.length - 2);
                }*/
            }

            /*r.free();

            return superBon;*/
            dfd.resolve(RebateBarcode, n);
        });
    });
    /* } else {
    dfd.resolve(0);
    return;
    }*/
    /* }

    $.when(new CRunClient().sendQuery(sql, callback, "POSysseus_Reports")).then(function (error) {
    if (error) {

    var text = "Es ist leider ein Fehler aufgetreten!";
    POS.message.show(text, "warning", "OK");
    dfd.resolve();
    return;
    }

    })*/

    return dfd.promise();

}

CBonTransaction.prototype.getSuperBonRebate = function (sb_id) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var rebate = 0;

    var sql = "SELECT Rebate from REBS where REB_ID = " + sb_id; // + " and Qty = 1"
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (r.recordCount())
        if (rows.length > 0) {
            rebate = rows[0].Rebate;
        } else {
            //  rebate = null;
        }
        dfd.resolve(rebate);
        /*r.free();
        return rebate;*/
    });
    return dfd.promise();

}

CBonTransaction.prototype.registerPingFailure = function (VTSuccess) {
    /*privMan.enablePrivilege (privList);*/

    var d = new Date();
    var ts = (d / 1000).toFixed(0);

    if (VTSuccess)
        var typ = "POK";
    else
        typ = "PNK";

    var sql = "INSERT INTO BON (Closed, Start, End, POS_ID, Cancelled, Type, Exported) " +
        "VALUES (-1, " + ts + ", " + ts + ", " + POS.POSId + ", 0, '" + typ + "', 0)";

    POS.SQLiteCon.execute(sql);
}

CBonTransaction.prototype.getText2 = function (boneId) {

    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT Text2 FROM BONE WHERE BONE_ID = " + boneId;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (!r.recordCount())
        if (rows.length < 1) {
            dfd.resolve("");
            return;
            /*r.free();
            return "";*/

        }

        var text2 = rows[0].Text2;
        dfd.resolve(text2);
        /*r.free();

        return text2;*/
    });
    return dfd.promise();
}

CBonTransaction.prototype.updateLastExportedBONEId = function (boneId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    if (boneId > 0)
        boneId -= 1;
    else
        boneId = 0;

    var updateIt = false;

    try {
        var sql = "SELECT BONE_ID FROM EXP";
        var r = POS.SQLiteCon.execute(sql);
        $.when(r).then(function (rows) {
            //if (r.recordCount())
            if (rows.length > 0) {
                var exportedBONEId = rows[0].BONE_ID;
                if (boneId < exportedBONEId)
                    updateIt = true;
            }
            //r.free();

            if (updateIt) {
                sql = "UPDATE EXP SET BONE_ID = " + boneId;
                var r2 = POS.SQLiteCon.execute(sql);
                $.when(r2).then(function () {
                    log.add(4, "Info", "Last exported BONE_ID updated to " + boneId, "");
                    dfd.resolve();
                });

            } else {
                dfd.resolve();
            }
        },
            function (err) {
            throw new Error("could not update last exported bone_id = " + boneId);
        });
    } catch (e) {
        log.add(2, "Error", "could not update last exported bone_id = " + boneId, e);
        dfd.reject();
    }
    return dfd.promise();
}

CBonTransaction.prototype.saveZIP = function (bonId, ZIP) {
    /*privMan.enablePrivilege (privList);*/

    var sql = "INSERT OR REPLACE INTO ZIPS (BON_ID, ZIP, Exported) VALUES (" + bonId + ", '" + ZIP + "', 0)";
    POS.SQLiteCon.execute(sql);
}

CBonTransaction.prototype.getZIPForCustomer = function (custId) {
    var dfd = jQuery.Deferred();
    if (!custId) {
        dfd.resolve(false);
    }
    /*privMan.enablePrivilege (privList);*/

    var sql = "SELECT ZIP FROM CUST WHERE CUST_ID = " + custId;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        var ZIP = rows[0].ZIP;
        /*r.free();

        return ZIP;*/
        dfd.resolve(ZIP);
    });
    return dfd.promise();
}

CBonTransaction.prototype.isObsoleteAddress = function (custId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT BlueId FROM CUST WHERE CUST_ID = " + custId;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        var obsolete = rows[0].BlueId;
        //r.free();
        //return
        //obsolete == "0" ? false : true;
        dfd.resolve(obsolete == "0" ? false : true);
    });
    return dfd.promise();
}

CBonTransaction.prototype.getEANFromCustId = function (custId) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT Barcode FROM CUST WHERE CUST_ID = " + custId;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        var barcode = rows[0].Barcode;
        dfd.resolve(barcode);
        /*r.free();

        return barcode;*/
    });
    return dfd.promise();
}

CBonTransaction.prototype.getShopName = function () {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT * FROM SHOPS WHERE POS_ID = " + POS.POSId;
    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (!r.recordCount())
        if (rows.length < 1) {
            sql = "SELECT * FROM SHOPS WHERE POS_ID = 1";
            var r2 = POS.SQLiteCon.execute(sql);
            $.when(r2).then(function (rows) {
                var shopName = rows[0].Name;
                dfd.resolve(shopName);
            });

        } else {

            var shopName = rows[0].Name;
            dfd.resolve(shopName);
            /*r.free();
            return shopName;*/
        }
    });
    return dfd.promise();

}

CBonTransaction.prototype.getPOSUserName = function (UID) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT Name FROM U WHERE U_ID = " + UID;

    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function (rows) {
        //if (!r.recordCount())
        if (rows.length < 1) {
            dfd.resolve("");
            return;
            //return "";
        }
        var userName = rows[0].Name;
        dfd.resolve(userName);
        /*r.free();

        return userName;*/
    });
    return dfd.promise();
}

export { CBonTransaction };
